import { ViewportScroller } from '@angular/common';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { BsDatepickerConfig, BsDatepickerDirective, DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { MsalService } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MsalAuthService } from 'src/app/msal-auth.service';
import { SessionTimeoutService } from 'src/app/session-timeout-dialog/session-timeout.service';


@Component({
  selector: 'app-add-document',
  templateUrl: './add-document.component.html',
  styleUrls: ['./add-document.component.scss']
})
export class AddDocumentComponent implements OnInit, OnDestroy {

  baseUrl = "https://predev.one-qms.com/oneqms-service-v1/oneqms";
  //baseUrl = "http://localhost:8080/oneqms";
  documentData: any = {
    'expirationDate': Date
  };
  previousFileName: any = "";
  isProcessing = false;
  documentTypeDropdown: any = [];
  selectedDocumentType: any = null;
  selectedDocumentTypeValue: any = "";
  dropDownFordocumentTypeList: any = [];
  isParentDocument: boolean = false;
  parentFolderId: any;
  folderData: any = {};
  document: File | any;
  isFileValid: boolean = false;
  isCoverpageEnable: boolean = false;

  isShowViewer = false;
  isViewableFile = false;
  viewableExtensionsList: any = [];
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  uiDateFormat: any = 'DD-MMM-YYYY';
  uiDateTimeFormat: any = 'DD-MMM-YYYY HH:mm:ss'
  isShowCrFields: boolean = false;
  isCrFeildIsMandatory: boolean = false;
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  }; templateData: any;
  statusDropdown: any = [];
  reasonDropdown: any = [];
  rejectReasonDropdown: any = [];
  selectedReason: any = null;
  selectedRejectReason: any = null;
  selectedStatus: any;

  documentTypeSearchText: string = '';
  designationSearchText: string = '';
  rejectReasonSearchText: string = '';
  reasonSearchText: string = '';
  groupSearchText: string = '';
  issuanceSearchText: string = '';
  departmentSearchText: string = '';
  accessToken: string;
  tempDateExpiration: any = null;

  isChildCancelCheckoutFlag: boolean = false;
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  cancelDownloadFunction() {
    this.visibleSDownloadPopup.close();
  }

  changeInChild(event: any) {
    if (event) {
      this.visibleSDownloadPopup.close();
    }
  }

  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  visibleConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;

  visibleConfirmCoauthor: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmPopupCoauthor', { static: true }) confirmPopupCoauthor: TemplateRef<any>;

  visibleConfirmWithData: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithDataPopup', { static: true }) confirmWithDataPopup: TemplateRef<any>;

  visibleCrInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;

  popupTitle: string | null = 'title';
  @ViewChild('searchUser', { static: true }) searchUser: TemplateRef<any>;
  @ViewChild('searchDocument', { static: true }) searchDocument: TemplateRef<any>;
  @ViewChild('searchCr', { static: true }) searchCr: TemplateRef<any>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchDocumentPopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchCrPopup: MatDialogRef<TemplateRef<any>>;

  visiblPublishPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('publishPopup', { static: true }) publishPopup: TemplateRef<any>;

  publishPopupConfig = {
    width: '75%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  visiblPublishConfirmPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('publishConfirmPopup', { static: true }) publishConfirmPopup: TemplateRef<any>;

  publishConfirmPopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  searchUserConfig = {
    width: '100%',
    height: '80vh',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  searchDocumentConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };


  crInfoPopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  searchCrConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  confirmWithDataPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  dateFormat: any = this.message.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.message.organizationDetails?.dateFormat;
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  public readonly $commonDateConfig: Readonly<Partial<BsDatepickerConfig>> = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  };

  public $getDateConfig(field: any): Readonly<Partial<BsDatepickerConfig>> {
    let minDate: Date | null = null;
    let maxDate: Date | null = null;

    const lov = String(field.fieldLovValues ?? '').trim();

    if (lov == "Current Date") {
      minDate = new Date();
      maxDate = new Date();

    } else if (lov == "Future Date") {
      minDate = new Date();
      maxDate = null;

    } else if (lov == "Past Date") {
      minDate = null;
      maxDate = new Date();

      /* Current Date + n days */
    } else if (lov.includes("+")) {
      minDate = new Date();
      const x = new Date();
      maxDate = new Date();
      maxDate.setDate(x.getDate() + Number.parseInt(lov.split("+")[1]));

      /* Current Date - n days */
    } else if (lov.includes("-")) {
      const x = new Date();
      minDate = new Date();
      minDate.setDate(x.getDate() - Number.parseInt(lov.split("-")[1]));
      maxDate = new Date();
    }

    return {
      ...this.$commonDateConfig,
      dateInputFormat: this.dateFormat,
      minDate: minDate!,
      maxDate: maxDate!
    };
  }

  public onDateChange(datepicker: BsDatepickerDirective): void {
    setTimeout(() => { datepicker.show(); }, 0);
  }

  public $getDateTimeConfig(field: any): Readonly<Partial<BsDatepickerConfig>> {
    let minDate: Date | null = null;
    let maxDate: Date | null = null;

    const lov = String(field.fieldLovValues ?? '').trim();

    if (lov == "Current Date") {
      minDate = new Date();
      maxDate = new Date();

    } else if (lov == "Future Date") {
      minDate = new Date();
      maxDate = null;

    } else if (lov == "Past Date") {
      minDate = null;
      maxDate = new Date();

      /* Current Date + n days */
    } else if (lov.includes("+")) {
      minDate = new Date();
      const x = new Date();
      maxDate = new Date();
      maxDate.setDate(x.getDate() + Number.parseInt(lov.split("+")[1]));

      /* Current Date - n days */
    } else if (lov.includes("-")) {
      const x = new Date();
      minDate = new Date();
      minDate.setDate(x.getDate() - Number.parseInt(lov.split("-")[1]));
      maxDate = new Date();
    }

    return {
      ...this.$commonDateConfig,
      dateInputFormat: this.dateFormat + ' HH:mm:ss',
      minDate: minDate!,
      maxDate: maxDate!,
      withTimepicker: true,
    };
  }

  operationFlag: any = "";
  taggedList: any = [];
  onclickedSaveButton: boolean = false;
  dateCustomClasses: DatepickerDateCustomClasses[];
  constructor(private authService1: MsalAuthService, private _formBuilder: FormBuilder, public appService: AppService, private router: Router, public dialog: MatDialog,
    private scroller: ViewportScroller, private snackBar: MatSnackBar, private activatedRoute: ActivatedRoute,
    readonly message: messageService, public paginationService: PaginationService, private authService: MsalService, private http: HttpClient, private readonly sessionTimeoutService: SessionTimeoutService) {
    const data: any = router.getCurrentNavigation()?.extras.state;
    this.documentData = data['documentData'];
    this.documentData['saveButtonForDocument'] = false;
    this.dropDownFordocumentTypeList = data['dropDownFordocumentTypeList']
    const now = new Date();

    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];

  }
  viewerValue: any;
  NotviewableValue: any;
  userPrivData: any = {};
  isVersionManually: boolean = false;
  isAdenabled: boolean = false;

  allowedFileExtns: any = "*.*";
  listOfDmsIssuanceTypes: any = [];
  displayUserName: any;
  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit(): void {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    this.displayUserName = userData.userNameAtApplication;
    this.message.isShowApplicableForAllCheckBox = false;
    let obj = JSON.parse(sessionStorage.getItem('getUserTimezoneDetails') || '{}');
    if (obj.uiDateFormat != undefined && obj.uiDateFormat != null) {
      this.uiDateFormat = obj.uiDateFormat.replace("DD", 'dd').replace("MON", "MMM").replace("YYYY", "yyyy");

    }
    if (obj.uiDateIMEFormat != undefined && obj.uiDateIMEFormat != null) {
      this.uiDateTimeFormat = obj.uiDateIMEFormat.replace("DD", 'dd').replace("HH24:MI:SS", 'HH:mm:ss').replace("MON", "MMM").replace("YYYY", "yyyy");
    }
    this.wvDocumentLoadedHandler = this.wvDocumentLoadedHandler.bind(this);
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.selectBoxeForDesignationCode();
    this.selectBoxeForDepartmentCode();
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y' ? true : false;
    this.parentFolderId = this.appService.getParentFolderId();
    this.appService.getDmsSettingVw().subscribe((dataDMSSetting: any) => {
      console.log("dataDMSSetting=", dataDMSSetting);

      this.message.tenantId = dataDMSSetting.tenantId;
      this.message.clientId = dataDMSSetting.clientId;
      this.message.hostName = dataDMSSetting.hostName;
      this.message.sitePath = dataDMSSetting.siteName;
    });
    this.appService.getDmsFolderDataById(this.parentFolderId)
      .subscribe((data: any) => {
        this.folderData = data[0];
        if (this.folderData.allowToInputVersionManually == "Y") {
          this.isVersionManually = true;
        } else {
          this.isVersionManually = false;
        }
        if (this.folderData.allowToInputDocumentNoManually == "Y") {
          this.isDocumentNoManually = true;
        } else {
          this.isDocumentNoManually = false;
        }
        for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
          this.documentTypeDropdown = this.documentTypeDropdown.concat({
            valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
            displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
          });
        }
        if (this.documentData['documentId'] == null || this.documentData['documentId'] == undefined) {
          if (this.folderData.documentTypeCode != null) {
            this.documentTypeDropdown = [];
            let docTypes = this.folderData.documentTypeCode.split(",");
            for (let j = 0; j < docTypes.length; j++) {
              for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
                if (docTypes[j] == this.dropDownFordocumentTypeList[i].documentTypeCode) {
                  this.documentTypeDropdown = this.documentTypeDropdown.concat({
                    valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
                    displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
                  });
                }
              }
            }
            this.callForFlexifields();

          } else {
            this.isDisableOverridingDocType = false;
          }
        } else {
          this.documentTypeDropdown = [];
          for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
            this.documentTypeDropdown = this.documentTypeDropdown.concat({
              valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
              displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
            });

          }
        }
        this.appService.getCodeListsByGroup("DOCUMENT_ISSUANCE_TYPE").subscribe((data: any) => {
          this.listOfDmsIssuanceTypes = data;

        })
        this.appService.getDmsSettingVw().subscribe((data: any) => {
          if (data.viewableFileExtns != null) {
            this.viewableExtensionsList = data.viewableFileExtns.split(",");
          }
          if (data.allowedFileExtns != null) {
            this.allowedFileExtns = null;
            let extns = data.allowedFileExtns.split(",");
            for (let i = 0; i < extns.length; i++) {
              this.allowedFileExtns = this.allowedFileExtns == null
                ? "." + extns[i].toLowerCase()
                : this.allowedFileExtns + "," + "." + extns[i].toLowerCase();
            }
          }

          this.getInitialCall();
        })
      })

    this.viewerValue = document.getElementById('viewerHideShow') as HTMLInputElement
    this.viewerValue.style.display = 'none';
    this.NotviewableValue = document.getElementById('isNotViewableFile') as HTMLInputElement
    if (this.documentData.onlineEditorMode == null) {
      this.NotviewableValue.style.display = 'block';
    } else {
      this.NotviewableValue.style.display = 'none';
    }

    this.appService.getDocumentPrivUser(this.parentFolderId).subscribe((data: any) => {
      this.userPrivData = data[0];
      if (this.userPrivData.blinded == "Y") {
        this.iSBlindTheDoc = true;
      }
    })
  }

  selectedTabIndex = 0;
  selectedTabIndex1 = 0;
  selectedTabIndex2 = 0;
  iSBlindTheDoc = false;
  isDisableOverridingDocType: boolean = false;
  tempDocTypeList: any = [];
  saveButtonForDocument: boolean = false;
  buttonLabels: any = [];
  stageName: any;
  crList: any = [];
  actionStatusOptions: any;
  instructions: any;
  isDocumentNoManually: boolean = false;
  isShowIsBlindedFlag = false;
  crDropdown: any = [];
  selectedCr: any = [];

  selectedCrValue: any;
  associatedDocumentsList: any = [];
  documentTypeListOfAssosciatedDocs: any = [];
  documentsByDocTypeList: any = [];
  taskStagesList: any = [];
  isDownloadTemplate: boolean = false;
  associatedDocumentListForCheckout: any = [];
  isAmendmentDocType: boolean = false;
  isOverrideExpDate = true;
  isOverrideEffectiveDate = true;

  getInitialCall() {
    this.onclickedSaveButton = false;
    if (this.documentData['documentId']) {
      this.documentData['module'] = "DOCS";
      if (this.documentData['effectiveDate'] != null) {
        this.documentData['effectiveDate'] = new Date(this.documentData['effectiveDate']);
        this.todayDate = new Date(this.documentData['effectiveDate']);
      }
      if (this.documentData['expirationDate'] != null) {
        this.documentData['expirationDate'] = new Date(this.documentData['expirationDate']);
      }
      this.documentData['isBlinded1'] = this.documentData['isBlinded'] === "Y";
      this.previousFileName = this.documentData['documentName'] + "." + this.documentData['documentExtn'];
      this.operationFlag = "EDIT"
      this.document = this.documentData['document'];

      this.isDocumentSaved = true;
      this.isViewableFile = false;
      if (this.documentData.documentExtn != null) {
        if (this.viewableExtensionsList.length > 0) {
          for (let q = 0; q < this.viewableExtensionsList.length; q++) {
            if (this.viewableExtensionsList[q].toUpperCase() == this.documentData.documentExtn.toUpperCase()) {
              this.isViewableFile = false;
              this.appService.getDocumentsToViewForDms(
                this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
                  if (this.documentData.documentExtn == 'jpg' || this.documentData.documentExtn == 'jpeg' ||
                    this.documentData.documentExtn == 'png' || this.documentData.documentExtn == 'JPG' ||
                    this.documentData.documentExtn == 'PNG' || this.documentData.documentExtn == 'JPEG') {
                    if (this.documentData.onlineEditorMode == null) {
                      this.showuploaddiv = true;
                      this.NotviewableValue.style.display = 'block';
                      this.viewerValue.style.display = 'block';
                      let blob = new Blob([data.body], { type: "image/*" });
                      let url = URL.createObjectURL(blob);
                      let image: any = document.getElementById("picture");
                      image.src = url;
                      this.isShowViewer = false;
                    }
                  } else {
                    if (this.documentData.onlineEditorMode == null || this.documentData.status != "Draft") {
                      this.isShowViewer = true;
                      this.loadDataInViewer(data, this.documentData.documentExtn, this.viewer);

                    }
                    this.document = data;
                  }

                })

              break;
            } else {
              this.isViewableFile = true;
              this.isShowToUploadDiffFile = true;
              this.NotviewableValue.style.display = 'none';
            }

          }
        } else {
          this.isViewableFile = true;
          this.isShowToUploadDiffFile = true;
          this.NotviewableValue.style.display = 'none';
        }

      }
      this.appService.getTaskStages(this.documentData['documentId'], this.documentData['version'])
        .subscribe((data: any) => {
          this.taskStagesList = data;
          this.isProcessing = false;
        })
      if (this.folderData.isDistributedFolder == "Y") {
        this.isProcessing = true;
        this.appService.getDocumentByDocumentIdForDistFolder(this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
          this.isProcessing = false;
          this.associatedDocumentsList = data;
          this.associatedDocumentListForCheckout = [];
          for (let k = 0; k < this.associatedDocumentsList.length; k++) {
            if (this.documentTypeListOfAssosciatedDocs.indexOf(this.associatedDocumentsList[k].documentTypeName) == -1) {
              this.documentTypeListOfAssosciatedDocs.push(this.associatedDocumentsList[k].documentTypeName);
            }
            for (let m = 0; m < this.dropDownFordocumentTypeList.length; m++) {
              if (this.associatedDocumentsList[k].documentTypeName == this.dropDownFordocumentTypeList[m].documentTypeName) {
                if (this.dropDownFordocumentTypeList[m].isAmendementDocType != "Y") {
                  this.associatedDocumentListForCheckout.push(this.associatedDocumentsList[k]);
                }
              }
            }
          }
          for (let l = 0; l < this.documentTypeListOfAssosciatedDocs.length; l++) {
            const list = [];
            const key = this.documentTypeListOfAssosciatedDocs[l];
            for (let j = 0; j < this.associatedDocumentsList.length; j++) {
              if (this.associatedDocumentsList[j].documentTypeName == this.documentTypeListOfAssosciatedDocs[l]) {
                list.push(this.associatedDocumentsList[j]);
              }
            }
            this.documentsByDocTypeList[key] = list;
          }
        })
      } else {
        this.isProcessing = true;
        this.appService.getAssociatedDocumentsDetail(
          this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
            this.isProcessing = false;
            this.associatedDocumentsList = data;
            this.associatedDocumentListForCheckout = [];
            for (let k = 0; k < this.associatedDocumentsList.length; k++) {
              if (this.documentTypeListOfAssosciatedDocs.indexOf(this.associatedDocumentsList[k].documentTypeName) == -1) {
                this.documentTypeListOfAssosciatedDocs.push(this.associatedDocumentsList[k].documentTypeName);
              }
              for (let m = 0; m < this.dropDownFordocumentTypeList.length; m++) {
                if (this.associatedDocumentsList[k].documentTypeName == this.dropDownFordocumentTypeList[m].documentTypeName) {
                  if (this.dropDownFordocumentTypeList[m].isAmendementDocType != "Y") {
                    console.log("this.associatedDocumentsList[k]===", this.associatedDocumentsList[k]);
                    this.associatedDocumentListForCheckout.push(this.associatedDocumentsList[k]);
                  }
                }
              }
            }
            for (let l = 0; l < this.documentTypeListOfAssosciatedDocs.length; l++) {
              const list = [];
              const key = this.documentTypeListOfAssosciatedDocs[l];
              for (let j = 0; j < this.associatedDocumentsList.length; j++) {
                if (this.associatedDocumentsList[j].documentTypeName == this.documentTypeListOfAssosciatedDocs[l]) {
                  list.push(this.associatedDocumentsList[j]);
                }
              }
              this.documentsByDocTypeList[key] = list;
            }
          })
      }

      this.documentData['belongsToIndividual'] = 'N';
      for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
        if (this.dropDownFordocumentTypeList[i].documentTypeCode == this.documentData['documentTypeCode']) {
          this.documentTypeData = this.dropDownFordocumentTypeList[i];
          if (this.dropDownFordocumentTypeList[i].isAssociatedDocumentType == "Y") {
            this.isShowAssociatedDocumentField = true;
          }
          if (this.dropDownFordocumentTypeList[i].isAmendementDocType == "Y") {
            this.isAmendmentDocType = true;
          }
          if (this.dropDownFordocumentTypeList[i].belongsToIndividual == "Y") {
            this.isShowUserBelongsToField = true;
            this.documentData['belongsToIndividual'] = 'Y';
          }
          if (this.dropDownFordocumentTypeList[i].isExpiryApplicable == "Y") {
            this.isShowExpDate = true;
          }
          if (this.dropDownFordocumentTypeList[i].overrideEffectiveDate == "Y") {
            this.isOverrideEffectiveDate = true;
          } else if (this.dropDownFordocumentTypeList[i].overrideEffectiveDate == "N") {
            this.isOverrideEffectiveDate = false;
          } else {
            this.isOverrideEffectiveDate = true;
          }
          if (this.dropDownFordocumentTypeList[i].overrideExpiryDate == "Y") {
            this.isOverrideExpDate = true;
          } else if (this.dropDownFordocumentTypeList[i].overrideExpiryDate == "N") {
            this.isOverrideExpDate = false;
          } else {
            this.isOverrideExpDate = true;
          }
          if (this.dropDownFordocumentTypeList[i].isBlindable == "Y") {
            this.isShowIsBlindedFlag = true;
          }
          if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory" || this.dropDownFordocumentTypeList[i].crProcess == "Non Mandatory") {
            this.isShowCrFields = true;
            if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory") {
              this.isCrFeildIsMandatory = true;
            } else {
              this.isCrFeildIsMandatory = false;
            }
          } else {
            this.isShowCrFields = false;
          }
        }
      }
      if (this.documentData['documentTypeCode']) {
        this.selectedDocumentType = this.documentData['documentTypeCode'];
        /*  this.selectedDocumentType = [{
           valueExp: this.documentData['documentTypeCode'],
           displayExp: this.documentData['documentTypeName']
         }] */
      }
      this.selectedCrValue = this.documentData['crNo'];
      if (this.documentData['crNo'] != null) {
        for (let i = 0; i < this.crDropdown.length; i++) {
          if (this.crDropdown[i].valueExp == this.documentData['crNo']) {
            this.selectedCr = [{
              valueExp: this.crDropdown[i].valueExp,
              displayExp: this.crDropdown[i].displayExp
            }];
          }
        }
      }

      this.selectedDocumentTypeValue = this.documentData['documentTypeCode'];
      this.callForFlexifields();
      this.saveButtonForDocument = false;
      this.documentData['saveButtonForDocument'] = false;
      if (this.documentData['opern'] != "View") {
        this.isProcessing = true;
        let obj = {

          documentId: this.documentData['documentId'],
          version: this.documentData['version'],
          folderId: this.parentFolderId,
          status: this.documentData['status'],
          pageName: 'DOCUMENT'
        }
        this.appService.getDocumentButtonLabels(obj).subscribe((data: any) => {
          this.isProcessing = false;
          this.stageName = data.stageName;
          this.actionStatusOptions = data.actionStatusOptions;
          this.instructions = data.instructions;
          if (data.buttonLabels != null) {
            this.buttonLabels = data.buttonLabels.split(",");
            for (let i = 0; i < this.buttonLabels.length; i++) {
              if (this.buttonLabels[i] == "Save") {
                this.saveButtonForDocument = true;
                this.documentData['saveButtonForDocument'] = true;
                this.buttonLabels = this.buttonLabels.filter((obj: string) => { return obj !== "Save" });
                i--;
              }
              if (this.buttonLabels[i] == "Cancel") {
                this.buttonLabels = this.buttonLabels.filter((obj: string) => { return obj !== "Cancel" });
                i--;
              }
            }

          }
        })
      }

      this.appService.getDocumentTagged(this.documentData['documentId'])
        .subscribe((data: any) => {
          this.taggedList = data[0];
        })
    } else {
      this.operationFlag = "ADD";
      this.documentData['isBlinded1'] = false;
      this.documentData['belongsToIndividual'] = 'N';
      this.documentData['version'] = "";
      this.documentData['revisionHistory'] = null;
      this.documentData['effectiveDate'] = null;
      this.documentData['expirationDate'] = null;
      this.documentData['documentDescription'] = null
      this.documentData['crNo'] = null
      this.saveButtonForDocument = true;
      this.isMandatoryField = false;
      //this.selectedDocumentTypeValue = "";
      this.documentData['belongsToUserId'] = null;
      for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {

        if (this.dropDownFordocumentTypeList[i].documentTypeCode == this.documentData['documentTypeCode']) {
          this.documentTypeData = this.dropDownFordocumentTypeList[i];
          if (this.dropDownFordocumentTypeList[i].isAssociatedDocumentType == "Y") {
            this.isShowAssociatedDocumentField = true;
          }
          if (this.dropDownFordocumentTypeList[i].isAmendementDocType == "Y") {
            this.isAmendmentDocType = true;
          }
          if (this.dropDownFordocumentTypeList[i].belongsToIndividual == "Y") {
            this.isShowUserBelongsToField = true;
            this.documentData['belongsToIndividual'] = 'Y';
          }
          if (this.dropDownFordocumentTypeList[i].isBlindable == "Y") {
            this.isShowIsBlindedFlag = true;
          }
          if (this.dropDownFordocumentTypeList[i].isExpiryApplicable == "Y") {
            this.isShowExpDate = true;
          }
          if (this.dropDownFordocumentTypeList[i].overrideEffectiveDate == "Y") {
            this.isOverrideEffectiveDate = true;
          } else if (this.dropDownFordocumentTypeList[i].overrideEffectiveDate == "N") {
            if (this.documentData['effectiveDate'] == null) {
              this.documentData['effectiveDate'] = new Date();
            }
            this.isOverrideEffectiveDate = false;
          } else {
            this.isOverrideEffectiveDate = true;
          }
          if (this.dropDownFordocumentTypeList[i].overrideExpiryDate == "Y") {
            this.isOverrideExpDate = true;
          } else if (this.dropDownFordocumentTypeList[i].overrideExpiryDate == "N") {
            this.isOverrideExpDate = false;
          } else {
            this.isOverrideExpDate = true;
          }
          if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory" || this.dropDownFordocumentTypeList[i].crProcess == "Non Mandatory") {
            this.isShowCrFields = true;
            if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory") {
              this.isCrFeildIsMandatory = true;
            } else {
              this.isCrFeildIsMandatory = false;
            }
          } else {
            this.isShowCrFields = false;
          }
        }
      }
      if (this.documentData['addFrom'] == "Add From Template") {
        this.NotviewableValue = document.getElementById('isNotViewableFile') as HTMLInputElement
        this.NotviewableValue.style.display = 'none';
        if (this.documentTypeData.templateId != null && this.documentTypeData.templateId != undefined) {
          this.isProcessing = true;
          this.appService.getDmsDocumentTemplateVwDetailsByTemplateId(this.documentTypeData.templateId)
            .subscribe((data: any) => {
              if (data.isActive == 'N') {
                this.isProcessing = false;
                this.isViewableFile = false;
                this.showSnackBar("The template is Inactive", 'E');
                return
              }
              this.isProcessing = false;
              if (data) {
                this.templateData = data;

                this.isViewableFile = false;
                if (this.viewableExtensionsList.length > 0) {
                  for (let q = 0; q < this.viewableExtensionsList.length; q++) {
                    if (this.viewableExtensionsList[q].toUpperCase() == this.templateData.templateExtn.toUpperCase()) {
                      this.isViewableFile = false;
                      this.isProcessing = true;
                      this.appService.getDocumentTemplateToView(this.documentTypeData.templateId)
                        .subscribe((data: any) => {
                          this.isProcessing = false;
                          this.downloadTemplateData = data;
                          this.document = new Blob([data.body]);
                          this.documentData.documentExtn = this.templateData.templateExtn;
                          this.documentData.templateName = this.templateData.templateName;
                          this.previousFileName = this.templateData.templateName + "." + this.templateData.templateExtn;



                          if (this.documentData.documentExtn == 'jpg' || this.documentData.documentExtn == 'jpeg' ||
                            this.documentData.documentExtn == 'png' || this.documentData.documentExtn == 'JPG' ||
                            this.documentData.documentExtn == 'PNG' || this.documentData.documentExtn == 'JPEG') {
                            if (this.documentData.onlineEditorMode == null || this.documentData.status != 'Draft') {
                              this.showuploaddiv = true;
                              this.NotviewableValue.style.display = 'block';
                              this.viewerValue.style.display = 'block';
                              let blob = new Blob([data.body], { type: "image/*" });
                              let url = URL.createObjectURL(blob);
                              let image: any = document.getElementById("picture");
                              image.src = url;
                              this.isShowViewer = false;
                            }
                          } else {
                            if (this.documentData.onlineEditorMode == null || this.documentData.status != 'Draft') {
                              this.isShowViewer = true;
                              this.loadDataInViewer(data, this.templateData.templateExtn, this.viewer);
                              this.isDownloadTemplate = true;
                            }
                          }
                        })

                      break;
                    } else {
                      this.isViewableFile = true;
                      this.isShowToUploadDiffFile = true;
                      this.NotviewableValue.style.display = 'none';
                      this.isDownloadTemplate = false;
                    }

                  }
                } else {
                  this.isViewableFile = true;
                  this.isShowToUploadDiffFile = true;
                  this.NotviewableValue.style.display = 'none';
                  this.isDownloadTemplate = false;
                }
              } else {
                this.NotviewableValue = document.getElementById('isNotViewableFile') as HTMLInputElement
                if (this.documentData.onlineEditorMode == null || this.documentData.status != 'Draft') {
                  this.NotviewableValue.style.display = 'block';
                } else {
                  this.NotviewableValue.style.display = 'none';
                }
              }
            })

        } else {
          this.NotviewableValue = document.getElementById('isNotViewableFile') as HTMLInputElement
          if (this.documentData.onlineEditorMode == null || this.documentData.status != 'Draft') {
            this.NotviewableValue.style.display = 'block';
          } else {
            this.NotviewableValue.style.display = 'none';
          }
        }
      }
    }
  }

  // Add this method to AddDocumentComponent

  registerActivityListeners(instance: any): void {
    const iframeWindow = instance.UI.iframeWindow;
    if (!iframeWindow) return;

    const activityHandler = () => {
      this.sessionTimeoutService.notifyActivity();
    };
    iframeWindow.addEventListener('mousemove', activityHandler, { passive: true });
    iframeWindow.addEventListener('mousedown', activityHandler, { passive: true });
    iframeWindow.addEventListener('wheel', activityHandler, { passive: true });
    iframeWindow.addEventListener('keydown', activityHandler);
    iframeWindow.document.addEventListener('scroll', activityHandler, { passive: true });
  }

  selectedCrGroup: any = [];
  qmsGroupsList: any = [];
  checkoutcrId: any = null;
  checkoutcrNo: any = null;
  crValue: any = null;
  downloadTemplateData: any;
  uploadFilePath: any;
  uploadFilePathextension: any;
  searchCrFunction(value: any) {
    this.getSelectedCrNo = null;
    this.getSelectedCrId = null;
    if (value == "Checkout") {
      this.checkoutcrId = null;
      this.checkoutcrNo = null;
      this.selectedCrGroup = [];
      this.selectedCrGroupValue = null;
      this.searchedCrList = [];
      this.crValue = value;
      this.qmsGroupsList = [];

      this.appService.getQmsGroups().subscribe((data: any) => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].modules.includes('CR')) {
            this.qmsGroupsList.push(data[i]);
          }
        }

        this.selectedCrGroup = [];
        this.selectBoxeForGroupValue();

      })
      this.isShowSearchedCrGrid = false;
      this.visibleSearchCrPopup = this.dialog.open(this.searchCr, this.searchCrConfig);
    } else {
      if (this.saveButtonForDocument) {
        this.selectedCrGroup = [];
        this.selectedCrGroupValue = null;
        this.searchedCrList = [];
        this.crValue = value;
        this.qmsGroupsList = [];
        this.appService.getQmsGroups().subscribe((data: any) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].modules.includes('CR')) {
              this.qmsGroupsList.push(data[i]);
            }
          }

          this.selectedCrGroup = [];
          this.selectBoxeForGroupValue();

        })
        this.isShowSearchedCrGrid = false;
        this.visibleSearchCrPopup = this.dialog.open(this.searchCr, this.searchCrConfig);
      } else {

      }
    }


  }
  groupValueDropdown: any = [];
  selectedCrGroupValue: any = null;
  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];
    for (let i = 0; i < this.qmsGroupsList.length; i++) {
      this.groupValueDropdown.push({
        valueExp: this.qmsGroupsList[i].groupId,
        displayExp: this.qmsGroupsList[i].groupName
      });
    }
  }

  onGroupValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedCrGroupValue = item?.valueExp ?? null;
    }
  }

  onGroupValueSelectOld(item: any) {
    this.selectedCrGroupValue = item.valueExp;
  }

  onGroupValueRemoved(item: any) {

  }

  snackBarRef: any;

  showSnackBar(message: string, type: string) {
    this.snackBarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: 5000,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Warning!',
        buttonLabel: "Ok"
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackBarRef.onAction().subscribe(() => {
      this.snackBarRef.dismiss();
    });
  }


  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  gridResetFunction() {
    this.searchedCrList = [];
    this.selectedCrGroup = [];
    this.selectedCrGroupValue = null;
  }

  isShowSearchedCrGrid = false;
  searchedCrList: any = [];
  seachCrForDocumentsFunc() {
    if (this.selectedCrGroupValue == null || this.selectedCrGroupValue == "") {
      this.groupFieldValidation();
    } else {
      this.isProcessing = true;
      this.appService.getCrForDocuments(this.selectedCrGroupValue)
        .subscribe((data: any) => {
          this.searchedCrList = data;
          this.isProcessing = false;
          this.isShowSearchedCrGrid = true;
        })
    }

  }
  groupCss: any;
  groupCssReqdMsg: any;
  groupFieldValidation() {
    this.groupCss = document.getElementById('groupSearch') as HTMLInputElement;
    this.groupCssReqdMsg = document.getElementById('groupSearch-required-msg') as HTMLInputElement;

    if (this.selectedCrGroupValue == null || this.selectedCrGroupValue == "") {
      this.groupCss.style.border = '1px solid red';
      this.groupCssReqdMsg.style.display = 'block';
    } else {
      this.groupCss.style.border = 'none';
      this.groupCssReqdMsg.style.display = 'none';
    }
  }

  getSelectedCrNo: any = null
  getSelectedCrId: any = null
  warningMsg: any = null;
  searchCrChildCheckBoxs = false;
  previousCrData: any = {};
  searchCrChildCheckBoxChecked(e: any, cr: any, index: any) {
    if (e.target.checked) {
      cr.searchCrChildCheckBoxs = true;
      this.previousCrData.searchCrChildCheckBoxs = false;
      this.getSelectedCrNo = cr.crNo;
      this.getSelectedCrId = cr.crId;
      if (this.crValue == "Document") {
        this.isProcessing = true;
        this.appService.getCrCountForDoc(cr.crNo).subscribe((data: any) => {
          this.isProcessing = false;
          if (data > 0) {
            this.warningMsg = "The selected CR is already assigned to different document.";
            this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
          }
        })
      }

    } else {
      cr.searchCrChildCheckBoxs = false;
      this.getSelectedCrNo = null;
      this.getSelectedCrId = null;
    }

    this.previousCrData = cr;
  }

  okInfo() {
    this.visibleCrInfoPopup.close();
  }

  closeCoAuthor() {
    if (this.visibleConfirmCoauthor) {
      this.visibleConfirmCoauthor.close();
    }
  }

  addCrFunction() {
    if (this.crValue == "Checkout") {
      this.checkoutcrNo = this.getSelectedCrNo;
      this.checkoutcrId = this.getSelectedCrId;
    } else {
      this.documentData.crNo = this.getSelectedCrNo;
      this.documentData.crDetails = this.getSelectedCrId;
    }

    this.visibleSearchCrPopup.close();
  }

  cancelCrFunction() {
    this.visibleSearchCrPopup.close();
  }

  onTabChanged(event: any) {

  }

  onTabChanged1(event: any) {

  }

  onTabChanged2(event: any) {

  }

  documentTypeData: any = {};
  flexifields: any = null;
  flexiFieldsList: any = [];
  selectedFlexifieldValue: any = [];
  flexifieldObj: any = {};
  isShowFlexifieldBlock = false;
  callForFlexifields() {
    for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
      if (this.dropDownFordocumentTypeList[i].documentTypeCode == this.documentData['documentTypeCode']) {
        this.flexifields = this.dropDownFordocumentTypeList[i].listOfFlexifields;
        break;
      }
    }
    if (this.flexifields) {
      let obj = {

        flexifieldIds: this.flexifields,
        module: "DOCS"
      }
      this.appService.getFlexifieldsListForDocument(obj).subscribe((data: any) => {
        this.flexiFieldsList = data;
        this.isShowFlexifieldBlock = true;
        for (let i = 0; i < this.flexiFieldsList.length; i++) {
          this.flexiFieldsList[i].dropDownValues = [];
          this.flexiFieldsList[i].dropdowns = [];
          this.flexiFieldsList[i].checkedCheckBoxValue = [];
          this.flexiFieldsList[i].selectedFlexifieldValue = [];
          if (this.flexiFieldsList[i].fieldType == "Drop Down" || this.flexiFieldsList[i].fieldType == "Horizontal Checkbox Button" ||
            this.flexiFieldsList[i].fieldType == "Vertical Checkbox Button" || this.flexiFieldsList[i].fieldType == "Horizontal Radio Button" ||
            this.flexiFieldsList[i].fieldType == "Vertical Radio Button" || this.flexiFieldsList[i].fieldType == "Multiselect Drop Down") {
            if (this.flexiFieldsList[i].fieldLovValues != null) {
              this.flexiFieldsList[i].dropDownValues = this.flexiFieldsList[i].fieldLovValues.split(",");
              for (let j = 0; j < this.flexiFieldsList[i].dropDownValues.length; j++) {
                this.flexiFieldsList[i].dropdowns = this.flexiFieldsList[i].dropdowns.concat({
                  valueExp: this.flexiFieldsList[i].dropDownValues[j],
                  displayExp: this.flexiFieldsList[i].dropDownValues[j]
                });
              }
            }
          }
        }
        if (this.documentData['documentId'] != null) {
          this.appService.getFlexifieldDataWithDocIdAndVersion(this.documentData['documentId'],
            this.documentData['version']).subscribe((data: any) => {
              if (data.length > 0) {
                this.flexifieldObj = data[0];
                for (let j = 0; j < this.flexiFieldsList.length; j++) {
                  if (this.flexiFieldsList[j].mappingColumn != null) {
                    let finalvariable = this.makeVariable(this.flexiFieldsList[j]);
                    if (data[0][finalvariable] != null) {
                      this.flexiFieldsList[j].recordId = data[0].recordId;
                      if (this.flexiFieldsList[j].fieldDatatype == "Date" || this.flexiFieldsList[j].fieldDatatype == "Datetime") {
                        if (data[0][finalvariable] != null) {
                          this.flexiFieldsList[j].fieldDefaultValue = new Date(data[0][finalvariable]);
                        } else {
                          this.flexiFieldsList[j].fieldDefaultValue = null;
                        }

                      } else {
                        if (this.flexiFieldsList[j].fieldDatatype == "Number") {
                          this.flexiFieldsList[j].fieldDefaultValue = "" + data[0][finalvariable] + "";
                        } else {
                          this.flexiFieldsList[j].fieldDefaultValue = data[0][finalvariable];
                        }
                      }


                      if (this.flexiFieldsList[j].fieldType == "Drop Down") {
                        if (this.flexiFieldsList[j].fieldDatatype == "Number") {
                          this.flexiFieldsList[j].fieldDefaultValue = "" + data[0][finalvariable] + "";
                        } else {
                          this.flexiFieldsList[j].fieldDefaultValue = data[0][finalvariable];
                        }

                      }
                      if (this.flexiFieldsList[j].fieldType == "Multiselect Drop Down") {
                        if (this.flexiFieldsList[j].fieldDefaultValue != null && this.flexiFieldsList[j].fieldDefaultValue !== "") {
                          this.flexiFieldsList[j].selectedFlexifieldValue = this.flexiFieldsList[j].fieldDefaultValue.split(",");

                          if (this.flexiFieldsList[j].dropdowns &&
                            this.flexiFieldsList[j].selectedFlexifieldValue.length === this.flexiFieldsList[j].dropdowns.length) {
                            this.flexiFieldsList[j].multiSelection = true;
                          }
                        } else {
                          this.flexiFieldsList[j].selectedFlexifieldValue = [];
                        }
                      }

                      if (this.flexiFieldsList[j].fieldType == "Vertical Checkbox Button" || this.flexiFieldsList[j].fieldType == "Horizontal Checkbox Button") {
                        if (this.flexiFieldsList[j].fieldDefaultValue != null) {
                          if (this.flexiFieldsList[j].fieldDatatype == "Number") {
                            if (Number.isNaN(this.flexiFieldsList[j].fieldDefaultValue)) {
                              this.flexiFieldsList[j].checkedCheckBoxValue = this.flexiFieldsList[j].fieldDefaultValue.split(",");
                            } else {
                              this.flexiFieldsList[j].checkedCheckBoxValue.push(this.flexiFieldsList[j].fieldDefaultValue);
                            }

                          } else {
                            this.flexiFieldsList[j].checkedCheckBoxValue = this.flexiFieldsList[j].fieldDefaultValue.split(",");
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
        }
      })
    } else {
      this.isShowFlexifieldBlock = false;
    }

  }
  // s:any;
  @ViewChildren('multiselect') multiselect!: QueryList<MatSelect>;
  toggleAllFlexiSelection(value: any, field: any, index: any) {

    if (value === 'multiselect') {
      if (field.multiSelection) {
        field.selectedFlexifieldValue = field.dropdowns.map((x: any) => x.valueExp);
      } else {
        field.selectedFlexifieldValue = [];
      }
    }
  }

  onMultiflexiSelect(event: any, field: any, index: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        field.multiSelection = field.dropdowns.length === field.selectedFlexifieldValue.length;
      });
    }
  }

  onFlexifieldSelect(item: any, data: any) {
    data.fieldDefaultValue = item.valueExp;
  }

  onFlexifieldRemoved(item: any) {

  }

  wvDocumentLoadedHandler(): void {
    // you can access docViewer object for low-level APIs
    const { documentViewer, annotationManager, Annotations } = this.wvInstance.Core;

  }
  uploadProgress: number | null = null;
  isFileChanged: any = false;
  @ViewChild('viewer', { static: false }) viewer: ElementRef;
  @ViewChild('viewer1', { static: false }) viewer1: ElementRef;
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.isFileChanged = true;
      this.isShowViewer = true;
      this.previousFileName = file.name;

      this.document = file;
      this.documentData.documentExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      let name = file.name.substr(0, file.name.lastIndexOf('.'));
      if (this.documentData.documentName == "" || this.documentData.documentName == null) {
        this.documentData.documentName = name;
      }

      if (!this.allowedFileExtns.includes(this.documentData.documentExtn)) {
        let warningMsgType = "E";
        this.warningMsg = this.documentData.documentExtn + " file type is not allowed, please choose allowed file type.";
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: this.warningMsg,
            type: warningMsgType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: warningMsgType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      } else {


        let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
        const formData = new FormData();
        formData.append('file', file ? file : '');

        formData.append("pageName", "DMS");
        formData.append("fileName", name);
        formData.append("extension", extension);
        this.isProcessing = true;
        // this.appService.fileUploadToServer(formData)
        //   .subscribe((data: any) => {
        //     this.isProcessing = false;
        //     if (data.resultType == "S") {
        //       this.isFileValid = true;
        //       this.downloadTemplateData = data.file;
        //       this.uploadFilePathextension = extension;
        //       this.uploadFilePath = data.uploadPath + "/" + data.fileName;

        //     } else {
        //       this.isFileValid = false;
        //       this.document = null;
        //       this.uploadFilePathextension = null;
        //       this.uploadFilePath = data.uploadPath + "/" + data.fileName;
        //       this.documentData.documentExtn = '';
        //       let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        //         duration: 5000,
        //         data: {
        //           message: data.result,
        //           type: data.resultType == 'S' ? 'Success' : 'Error',
        //           buttonLabel: "Ok"
        //         },
        //         horizontalPosition: 'center',
        //         verticalPosition: 'top',
        //         panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        //       });
        //       sb.onAction().subscribe(() => {
        //         sb.dismiss();
        //       });
        //     }
        //   }, (error) => {
        //     this.displayMessage = error;
        //     this.displaySuccessMessage = false;
        //     this.displayErrorMessage = true;
        //     this.isProcessing = false;
        //     throw error;
        //   })
        this.http.post(this.baseUrl + '/fileUploader/singleFile', formData, {
          reportProgress: true,
          observe: 'events',
        }).subscribe(event => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            this.isProcessing = false;
            this.uploadProgress = Math.round((event.loaded / event.total) * 100);

          } else if (event.type === HttpEventType.Response) {
            this.isProcessing = true;

            console.log('Upload complete', event.body);
            let response: any = event.body || {};
            this.uploadProgress = null;
            this.isViewableFile = false;
            this.isFileValid = true;
            this.downloadTemplateData = response.file;
            this.uploadFilePathextension = response.extension;
            this.uploadFilePath = response.uploadPath + "/" + response.fileName;
            this.isProcessing = false;
            if (this.viewableExtensionsList.length > 0) {
              for (let q = 0; q < this.viewableExtensionsList.length; q++) {
                if (this.viewableExtensionsList[q].toUpperCase() == this.documentData.documentExtn.toUpperCase()) {
                  console.log("this.viewableExtensionsList[q].toUpperCase()===", this.viewableExtensionsList[q].toUpperCase());
                  if (this.documentData.onlineEditorMode == null || this.documentData.status != 'Draft') {
                    this.isViewableFile = false;
                    this.loadDataInViewer(this.document, null, this.viewer);
                    break;
                  }
                } else {
                  console.log("this.viewableExtensionsList[q].toUpperCase()===", this.viewableExtensionsList[q].toUpperCase());
                  this.isViewableFile = true;
                  this.isShowToUploadDiffFile = true;
                  this.NotviewableValue.style.display = 'none';
                }

              }
            } else {
              console.log("this.viewableExtensionsList[q].toUpperCase()===");
              this.isViewableFile = true;
              this.isShowToUploadDiffFile = true;
              this.NotviewableValue.style.display = 'none';
            }
          }
        });
      }


    } else {
      this.isShowViewer = false;
      this.document = '';
      this.documentData.documentExtn = '';
    }
  }


  isShowUserBelongsToField = false;
  isShowAssociatedDocumentField = false;
  isShowExpDate = false;
  followSameExpDate = false;
  ondocumentTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedDocumentTypeValue = item.valueExp;
        this.isShowAssociatedDocumentField = false;
        this.isShowUserBelongsToField = false;
        this.isAmendmentDocType = false;
        this.isShowExpDate = false;
        this.followSameExpDate = false;
        this.documentData['documentTypeCode'] = this.selectedDocumentTypeValue;

        for (const element of this.dropDownFordocumentTypeList) {
          if (element.documentTypeCode == item.valueExp) {
            this.documentTypeData = element;
            if (element.isAssociatedDocumentType == "Y") {
              this.isShowAssociatedDocumentField = true;
            }
            if (element.isAmendementDocType == "Y") {
              this.isAmendmentDocType = true;
            }
            if (element.belongsToIndividual == "Y") {
              this.isShowUserBelongsToField = true;
            }
            if (element.isExpiryApplicable == "Y") {
              this.isShowExpDate = true;
            }
            if (element.isBlindable == "Y") {
              this.isShowIsBlindedFlag = true;
            }
            if (element.crProcess == "Mandatory" || element.crProcess == "Non Mandatory") {

              this.isShowCrFields = true;
              if (element.crProcess == "Mandatory") {
                this.isCrFeildIsMandatory = true;
              } else {
                this.isCrFeildIsMandatory = false;
              }
            } else {
              this.isShowCrFields = false;
            }

            if (element.associatedDocToFollowSameExpiry == "Y") {
              this.followSameExpDate = true;
            }
          }
        }

        if (!this.isOverrideEffectiveDate) {
          if (this.documentData['effectiveDate'] == null) {
            this.documentData['effectiveDate'] = new Date();
          }

        }

        if (this.documentData['addFrom'] == "Add From Template") {

          if (this.documentTypeData.templateId != null && this.documentTypeData.templateId != undefined) {
            this.isProcessing = true;
            this.appService.getDmsDocumentTemplateVwDetailsByTemplateId(this.documentTypeData.templateId)
              .subscribe((data: any) => {
                if (data.isActive == 'N') {
                  this.isProcessing = false;
                  this.isViewableFile = false;
                  this.showSnackBar("The template is Inactive", 'E');
                  return
                }
                this.isProcessing = false;
                this.templateData = data;
                this.isViewableFile = false;
                if (this.viewableExtensionsList.length > 0) {
                  for (const element of this.viewableExtensionsList) {
                    if (element.toUpperCase() == this.templateData.templateExtn.toUpperCase()) {
                      this.isViewableFile = false;
                      this.isProcessing = true;
                      this.appService.getDocumentTemplateToView(this.documentTypeData.templateId)
                        .subscribe((data: any) => {
                          this.isProcessing = false;
                          this.downloadTemplateData = data;
                          this.document = new Blob([data.body]);
                          this.documentData.document = this.templateData.template;
                          this.documentData.documentExtn = this.templateData.templateExtn;
                          this.documentData.templateName = this.templateData.templateName;
                          this.previousFileName = this.templateData.templateName + "." + this.templateData.templateExtn;



                          if (this.documentData.documentExtn == 'jpg' || this.documentData.documentExtn == 'jpeg' ||
                            this.documentData.documentExtn == 'png' || this.documentData.documentExtn == 'JPG' ||
                            this.documentData.documentExtn == 'PNG' || this.documentData.documentExtn == 'JPEG') {

                            if (this.documentData.onlineEditorMode == null || this.documentData.status != 'Draft') {
                              this.showuploaddiv = true;
                              this.NotviewableValue.style.display = 'block';
                              this.viewerValue.style.display = 'block';
                              let blob = new Blob([data.body], { type: "image/*" });
                              let url = URL.createObjectURL(blob);
                              let image: any = document.getElementById("picture");
                              image.src = url;
                              this.isShowViewer = false;
                            }

                          } else {
                            if (this.documentData.onlineEditorMode == null || this.documentData.status != 'Draft') {
                              this.isShowViewer = true;
                              this.loadDataInViewer(data, this.templateData.templateExtn, this.viewer);
                              this.isDownloadTemplate = true;
                            }
                          }
                        })
                      break;
                    } else {
                      this.isViewableFile = true;
                      this.isShowToUploadDiffFile = true;
                      this.NotviewableValue.style.display = 'none';
                      this.isDownloadTemplate = false;
                    }
                  }
                } else {
                  this.isViewableFile = true;
                  this.isShowToUploadDiffFile = true;
                  this.NotviewableValue.style.display = 'none';
                  this.isDownloadTemplate = false;
                }
              })
          } else {
            this.NotviewableValue = document.getElementById('isNotViewableFile') as HTMLInputElement
            if (this.documentData.onlineEditorMode == null || this.documentData.status != 'Draft') {
              this.NotviewableValue.style.display = 'block';
            } else {
              this.NotviewableValue.style.display = 'none';
            }
          }
        }
        this.callForFlexifields();
      } else {
        this.selectedDocumentTypeValue = "";
        this.isShowCrFields = false;
        this.isShowIsBlindedFlag = false;
        this.isShowAssociatedDocumentField = false;
        this.isShowUserBelongsToField = false;
      }
    }
  }

  ondocumentTypeSelectOld(item: any) {
    this.selectedDocumentTypeValue = item.valueExp;
    this.isShowAssociatedDocumentField = false;
    this.isShowUserBelongsToField = false;
    this.isAmendmentDocType = false;
    this.isShowExpDate = false;
    this.documentData['documentTypeCode'] = this.selectedDocumentTypeValue;
    for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
      if (this.dropDownFordocumentTypeList[i].documentTypeCode == item.valueExp) {
        this.documentTypeData = this.dropDownFordocumentTypeList[i];
        if (this.dropDownFordocumentTypeList[i].isAssociatedDocumentType == "Y") {
          this.isShowAssociatedDocumentField = true;
        }
        if (this.dropDownFordocumentTypeList[i].isAmendementDocType == "Y") {
          this.isAmendmentDocType = true;
        }
        if (this.dropDownFordocumentTypeList[i].belongsToIndividual == "Y") {
          this.isShowUserBelongsToField = true;
        }
        if (this.dropDownFordocumentTypeList[i].isExpiryApplicable == "Y") {
          this.isShowExpDate = true;
        }
        if (this.dropDownFordocumentTypeList[i].isBlindable == "Y") {
          this.isShowIsBlindedFlag = true;
        }
        if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory" || this.dropDownFordocumentTypeList[i].crProcess == "Non Mandatory") {

          this.isShowCrFields = true;
          if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory") {
            this.isCrFeildIsMandatory = true;
          } else {
            this.isCrFeildIsMandatory = false;
          }
        } else {
          this.isShowCrFields = false;
        }
      }
    }
    if (!this.isOverrideEffectiveDate) {
      if (this.documentData['effectiveDate'] == null) {
        this.documentData['effectiveDate'] = new Date();
      }
    }
    if (this.documentData['addFrom'] == "Add From Template") {

      if (this.documentTypeData.templateId != null && this.documentTypeData.templateId != undefined) {
        this.isProcessing = true;
        this.appService.getDmsDocumentTemplateVwDetailsByTemplateId(this.documentTypeData.templateId)
          .subscribe((data: any) => {
            if (data.isActive == 'N') {
              this.isProcessing = false;
              this.isViewableFile = false;
              this.showSnackBar("The template is Inactive", 'E');
              return
            }
            this.isProcessing = false;
            this.templateData = data;
            this.isViewableFile = false;
            if (this.viewableExtensionsList.length > 0) {
              for (let q = 0; q < this.viewableExtensionsList.length; q++) {
                if (this.viewableExtensionsList[q].toUpperCase() == this.templateData.templateExtn.toUpperCase()) {
                  this.isViewableFile = false;
                  this.isProcessing = true;
                  this.appService.getDocumentTemplateToView(this.documentTypeData.templateId)
                    .subscribe((data: any) => {
                      this.isProcessing = false;
                      this.downloadTemplateData = data;
                      this.document = new Blob([data.body]);
                      this.documentData.documentExtn = this.templateData.templateExtn;
                      this.documentData.templateName = this.templateData.templateName;
                      this.previousFileName = this.templateData.templateName + "." + this.templateData.templateExtn;

                      if (this.documentData.onlineEditorMode == null || this.documentData.status != 'Draft') {
                        this.loadDataInViewer(data, this.templateData.templateExtn, this.viewer);
                        this.isDownloadTemplate = true;
                      }
                    })

                  break;
                } else {
                  this.isViewableFile = true;
                  this.isShowToUploadDiffFile = true;
                  this.NotviewableValue.style.display = 'none';
                  this.isDownloadTemplate = false;
                }

              }
            } else {
              this.isViewableFile = true;
              this.isShowToUploadDiffFile = true;
              this.NotviewableValue.style.display = 'none';
              this.isDownloadTemplate = false;
            }

          })

      } else {
        this.NotviewableValue = document.getElementById('isNotViewableFile') as HTMLInputElement
        if (this.documentData.onlineEditorMode == null || this.documentData.status != 'Draft') {
          this.NotviewableValue.style.display = 'block';
        } else {
          this.NotviewableValue.style.display = 'none';
        }
      }
    }
    this.callForFlexifields();
  }

  closepdfviwer() {
    this.isBeforeSaveUploadDiffFile = true;
    this.showuploaddiv = false;
    this.isViewableFile = false;
    this.isShowToUploadDiffFile = false;
    this.document = null;
    this.uploadFilePath = null;
    this.uploadFilePathextension = null;
    this.isFileValid = false;
    this.viewerValue.style.display = 'none';
    this.NotviewableValue = document.getElementById('isNotViewableFile') as HTMLInputElement
    if (this.documentData.onlineEditorMode == null || this.documentData.status != 'Draft') {
      this.NotviewableValue.style.display = 'block';
    } else {
      this.NotviewableValue.style.display = 'none';
    }
  }
  ondocumentTypeRemoved(item: any) {
    this.selectedDocumentTypeValue = "";
    this.isShowCrFields = false;
    this.isShowIsBlindedFlag = false;
    this.isShowAssociatedDocumentField = false;
    this.isShowUserBelongsToField = false;
  }

  onCrSelect(item: any) {
    this.selectedCrValue = item.valueExp;
  }

  onCrRemoved(item: any) {
    this.selectedCrValue = "";

  }

  wvInstance: any;
  showuploaddiv: boolean = false;
  isShowToUploadDiffFile: boolean = false;
  loadDataInViewer(data: any, extn: any, viewerId: any) {
    this.showuploaddiv = true;
    this.NotviewableValue.style.display = 'block';
    this.viewerValue.style.display = 'block';

    // 1. Dynamically decide which document metadata to use based on the view state
    let currentDocData = this.viewAssociatedDoc ? this.clickedDoc : this.documentData;

    if (this.wvInstance != undefined && this.wvInstance.UI) {
      if (extn == null) {
        this.wvInstance.UI.loadDocument(data);
      } else if (extn === 'doc' || extn === 'docx') {
        console.log("extn==", extn);
        const file = new File([data.body], `input.${extn}`, {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });

        // 2. Use currentDocData instead of this.documentData
        if (currentDocData.documentId) {
          this.appService.downloadDocumentsDmsForDocPreview(currentDocData, currentDocData.documentName).subscribe(
            (response: any) => {
              console.log("previewPrint response.status =", response.status);
              if (response.status === 200) {
                this.isProcessing = false;
                const contentType = response.headers.get('content-type');
                const blob = new Blob([response.body], { type: contentType });
                this.wvInstance.UI.loadDocument(blob, { extension: 'pdf' });
              }
            });
        } else {
          this.wvInstance.UI.loadDocument(data.body, { extension: extn });
        }

      } else {
        this.wvInstance.UI.loadDocument(data.body, { extension: extn });
      }
    } else {
      WebViewer({
        path: '../../../wv-resources/lib',
        licenseKey: 'Clinevo Technologies Private Limited (clinevotech.com):OEM:eTrials::B+:AMS(20231004):FEA5C54D0427360AF360B13AC982737B60610F8BAF461E35E56C05DA5C956EAE0AFAB6F5C7', // sign up to get a key at https://dev.apryse.com
        fullAPI: true,
        disabledElements: [
          'leftPanelButton',
          'toolbarGroup-Annotate',
          'highlightToolGroupButton',
          'underlineToolGroupButton',
          'strikeoutToolGroupButton',
          'squigglyToolGroupButton',
          'freeTextToolGroupButton',
          'shapeToolGroupButton',
          'stickyToolGroupButton',
          'freeHandToolGroupButton',
          'toolsOverlay',
          'eraserToolButton',
          'redoButton',
          'stickyToolButton',
          'textPopup',
          'toggleNotesButton',
          'selectToolButton',
          'highlightToolButton',
          'freeHandToolButton',
          'freeTextToolButton',
          'toolsHeader',
          'printButton',
        ]
      }, viewerId.nativeElement).then((instance: any) => {
        this.wvInstance = instance;
        this.registerActivityListeners(instance);
        instance.UI.disableElements(['printButton']);
        instance.UI.disableFeatures([instance.UI.Feature.Print]);

        // Also block Ctrl+P inside viewer (built-in PDFTron shortcut)
        instance.UI.addEventListener(instance.UI.Events.KEY_DOWN, (e: KeyboardEvent) => {
          if (e.ctrlKey && e.key.toLowerCase() === 'p') {
            e.preventDefault();
            e.stopPropagation();
            alert('Printing is disabled.');
            return false;
          } else {
            return true;
          }
        });

        const docViewer = instance.docViewer;
        const annotManager = instance.annotManager;
        let Feature = instance.Feature;
        instance.UI.setTheme('dark');
        instance.print = false;

        instance.UI.disableElements(['toolbarGroup-Shapes']);
        instance.UI.disableElements(['toolbarGroup-Edit']);
        instance.UI.disableElements(['toolbarGroup-Insert']);
        instance.UI.disableElements(['menuButton']);
        instance.UI.disableElements(['undoButton']);
        instance.UI.disableElements(['highlightToolGroupButton']);

        let FitMode = instance.FitMode;
        if (extn == null) {
          console.log("extn==", extn);
          // 3. Fallback to passed 'data' instead of 'this.document'
          instance.UI.loadDocument(data ? data : this.document);
        } else if (extn === 'doc' || extn === 'docx') {
          console.log("extn==", extn);
          const file = new File([data.body], `input.${extn}`, {
            type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          });

          // 4. Use currentDocData instead of this.documentData
          if (currentDocData.documentId) {
            this.appService.downloadDocumentsDmsForDocPreview(currentDocData, currentDocData.documentName).subscribe(
              (response: any) => {
                console.log("previewPrint response.status =", response.status);
                if (response.status === 200) {
                  this.isProcessing = false;
                  const contentType = response.headers.get('content-type');
                  const blob = new Blob([response.body], { type: contentType });
                  this.wvInstance.UI.loadDocument(blob, { extension: 'pdf' });
                }
              });
          } else {
            this.wvInstance.UI.loadDocument(data.body, { extension: extn });
          }
        } else {
          console.log("extn==", extn);
          instance.UI.loadDocument(data.body, { extension: extn });
        }

        const { documentViewer } = instance.Core;
        documentViewer.addEventListener('documentLoaded', () => {
          console.log("doc loaded");
        });

        const UIEvents = instance.UI.Events;
        instance.UI.addEventListener(UIEvents.LOAD_ERROR, function (err: any) {
          console.log(err);
        });

        instance.Core.documentViewer.addEventListener('documentLoaded', this.wvDocumentLoadedHandler);
        setTimeout(() => {
          if (!this.isCoverpageEnable && this.documentData['status'] === 'Published' && !this.viewAssociatedDoc) {
            this.onCoverPageCheckboxAutoChanged();
            console.log("this.isCoverpageEnable==", this.isCoverpageEnable);
          }
        }, 7000);
      })
    }
  }

  isBeforeSaveUploadDiffFile: any = false;
  downloadtemplate(event: any) {
    event.preventDefault();
    let contentData = "";
    if (this.documentData.documentId == null || this.documentData.documentId == undefined) {
      if (this.documentData.templateName != null && this.documentData.templateName != undefined && this.documentData.templateName != "") {
        const blob = new Blob([this.downloadTemplateData.body]);
        let url = URL.createObjectURL(blob);
        contentData = url;
      } else {
        contentData = "data:application/octet-stream;base64," + this.downloadTemplateData;
      }
    } else {
      if (this.isBeforeSaveUploadDiffFile) {
        contentData = "data:application/octet-stream;base64," + this.downloadTemplateData;
      } else {
        const blob = new Blob([this.document.body]);
        let url = URL.createObjectURL(blob);
        contentData = url;
      }

    }


    let downloadLink = document.createElement("a");
    downloadLink.href = contentData;

    downloadLink.download = this.previousFileName;
    downloadLink.click();
  }

  searchUserParentCheckBox: boolean = false;
  searchUserChildCheckBoxs: boolean = false;
  searchUserChildCheckBoxsMenu: boolean = false;

  searchUserDataGridParentCheckBoxChecked(e: any) {

    if (e.target.checked == true) {

      for (const item of this.getOneQmsUsersVwDetailsTableData) {
        item.searchUserChildCheckBoxs = true;
      }

    } else {
      for (let k = 0; k < this.getOneQmsUsersVwDetailsTableData.length; k++) {
        this.getOneQmsUsersVwDetailsTableData[k].searchUserChildCheckBoxs = false;
      }

    }
  }

  getSelectedUserId: any;
  getSelectedUserName: String;
  searchUserChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      // 1. Loop through all rows and uncheck them
      this.getOneQmsUsersVwDetailsTableData.forEach((user: any) => {
        user.searchUserChildCheckBoxs = false;
      });

      // 2. Check only the current row
      listOfUsersVwDetails.searchUserChildCheckBoxs = true;

      // 3. Store the selected values
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      // If the user unchecks the currently selected box
      listOfUsersVwDetails.searchUserChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
  }

  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];

  popupDataTitle: any = {
    title: ''
  };

  searchUserFunction() {
    if (this.saveButtonForDocument) {
      this.searchUserChildCheckBoxs = false;
      this.showUserSearchGrid = false;
      this.searchByUserName = null;
      this.searchByFirstName = null;
      this.searchByLastName = null;
      this.searchByDesignationCode = null;
      this.searchByDepartmentCode = null;
      this.popupDataTitle.title = "Search User";
      this.visibleSearchUserPopup = this.dialog.open(this.searchUser, this.searchUserConfig);
    } else {

    }

  }

  addUserNameFunction() {
    this.documentData.belongsUserId = this.getSelectedUserId;
    this.documentData.belongsUserName = this.getSelectedUserName;
    this.visibleSearchUserPopup.close();
  }

  cancelSearchUserFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    this.visibleSearchUserPopup.close();
  }

  searchUserGridDataFunction() {
    this.isProcessing = true;
    this.designationCodeValue = this.searchByDesignationCode ?? null;
    this.departmentCodeValue = this.searchByDepartmentCode ?? null



    let searchByUserName;
    if (this.searchByUserName) {
      searchByUserName = this.searchByUserName.toUpperCase();
    } else {
      this.searchByUserName = '';
    }
    this.searchOneQmsUserVwDetails = {
      userName: searchByUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      status: "active"
    };
    if (this.userPrivData.author == "Y") {
      this.searchOneQmsUserVwDetails.userPriv = "AUTHOR";
    } else if (this.userPrivData.allusrAuthor == "Y" && this.userPrivData.rmAuthor == "Y") {
      this.searchOneQmsUserVwDetails.userPriv = "ALLUSERRMAUTHOR";
    } else if (this.userPrivData.allusrAuthor == "Y") {
      this.searchOneQmsUserVwDetails.userPriv = "ALLUSERAUTHOR";
    } else if (this.userPrivData.rmAuthor == "Y") {
      this.searchOneQmsUserVwDetails.userPriv = "RMAUTHOR";
    }
    this.appService.searchUsersForDmsDocuments(this.searchOneQmsUserVwDetails).subscribe((response: any) => {
      this.getOneQmsUsersVwDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
      //console.log(this.getOneQmsUsersVwDetailsTableData);
    })
  }

  resetSearchUserGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }

  selectBoxeForDesignationCode() {
    for (let i = 0; i < this.dropDownForDesignationCode.length; i++) {
      this.designationCodeDropdown = this.designationCodeDropdown.concat({
        valueExp: this.dropDownForDesignationCode[i].codelistCode,
        displayExp: this.dropDownForDesignationCode[i].codelistName
      });
    }
  }

  selectBoxeForDepartmentCode() {
    for (let i = 0; i < this.dropDownForDepartmentCode.length; i++) {
      this.departmentCodeDropdown = this.departmentCodeDropdown.concat({
        valueExp: this.dropDownForDepartmentCode[i].codelistCode,
        displayExp: this.dropDownForDepartmentCode[i].codelistName
      });
    }
  }

  selectedDesignationValue: any;
  selectedDepartmentValue: any;
  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedDesignationValue = item?.valueExp ?? null;
    }
  }
  onDesignationCodeSelectOld(item: any) {

    this.selectedDesignationValue = item.valueExp;
  }
  onDesignationCodeRemoved(item: any) { }

  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedDepartmentValue = item?.valueExp ?? null;
    }
  }
  onDepartmentCodeSelectOld(item: any) {

    this.selectedDepartmentValue = item.valueExp;
  }
  onDepartmentCodeRemoved(item: any) { }

  searchDocumentParentCheckBox: boolean = false;
  searchDocumentChildCheckBoxs: boolean = false;
  searchDocumentChildCheckBoxsMenu: boolean = false;

  searchDocumentDataGridParentCheckBoxChecked(e: any) {
    //console.log(e);
    if (e.target.checked == true) {
      //this.searchManagerChildCheckBoxs = true;
      //this.searchManagerChildCheckBoxsMenu=true;
      for (let k = 0; k < this.getDmsDocumentsVwDetailsTableData.length; k++) {
        this.getDmsDocumentsVwDetailsTableData[k].searchDocumentChildCheckBoxs = true;
      }

    } else {
      for (let k = 0; k < this.getDmsDocumentsVwDetailsTableData.length; k++) {
        this.getDmsDocumentsVwDetailsTableData[k].searchDocumentChildCheckBoxs = false;
      }
      //this.searchManagerChildCheckBoxs = false;
      //this.searchManagerChildCheckBoxsMenu=false;
    }
  }

  getSelectedDocumentId: any;
  getSelectedDocumentName: String;
  searchDocumentChildCheckBoxChecked(e: any, listOfDocumentsVwDetails: any, idx: any) {
    // console.log(e);
    //console.log(listOfUsersVwDetails);
    //console.log(idx);

    if (e.target.checked) {
      listOfDocumentsVwDetails.searchDocumentChildCheckBoxs = true;
      this.getSelectedDocumentId = listOfDocumentsVwDetails.documentId;
      this.getSelectedDocumentName = listOfDocumentsVwDetails.documentName;
    } else {
      listOfDocumentsVwDetails.searchDocumentChildCheckBoxs = false;
      this.getSelectedDocumentId = null;
      this.getSelectedDocumentName = '';
    }

  }

  model = {
    documentData: {},
  };
  selectedAssociatedDoc: any = {};
  changeInFolderStructureChild(data: any) {
    this.model = data;
    this.selectedAssociatedDoc = this.model.documentData;
  }

  showDocumentsSearchGrid: boolean;
  searchByDocumentId: any = null;
  searchByDocumetnName: any = null;
  searchByDocumentType: any = [];
  documentTypeValue: any;
  searchDmsDocumentsVwDetails: any;
  getDmsDocumentsVwDetailsTableData: any = [];

  searchDocumentFunction() {
    if (this.saveButtonForDocument) {
      this.searchDocumentChildCheckBoxs = false;
      this.showDocumentsSearchGrid = false;
      this.searchByDocumentId = null;
      this.searchByDocumetnName = null;
      this.searchByDocumentType = [];
      this.popupDataTitle.title = "Search Document";
      this.visibleSearchDocumentPopup = this.dialog.open(this.searchDocument, this.searchDocumentConfig);
    } else {

    }

  }

  addDocumentFunction() {
    if (this.selectedAssociatedDoc.documentId != undefined || this.selectedAssociatedDoc.documentId != null) {
      this.documentData.associatedDocumentId = this.selectedAssociatedDoc.documentId;
      this.documentData.associatedDocumentName = this.selectedAssociatedDoc.documentName;
      this.documentData.associatedFolderPath = this.selectedAssociatedDoc.folderPath;
      if (this.isShowExpDate && this.followSameExpDate) {
        if (this.selectedAssociatedDoc.expirationDate != null) {
          this.tempDateExpiration = new Date(this.selectedAssociatedDoc.expirationDate);
          this.documentData.expirationDate = new Date(this.selectedAssociatedDoc.expirationDate);
        }
      }

      this.documentData.associatedStatus = this.selectedAssociatedDoc.status;
      this.visibleSearchDocumentPopup.close();
    } else {
      alert("Please select document!")
    }

  }

  cancelSearchDocumentFunction() {
    this.getSelectedDocumentId = null;
    this.getSelectedDocumentName = '';
    this.visibleSearchDocumentPopup.close();
  }

  searchDocumentGridDataFunction() {
    this.isProcessing = true;
    if (this.searchByDocumentType.length != 0) {
      this.documentTypeValue = this.searchByDocumentType[0].valueExp;
    } else {
      this.documentTypeValue = null;
    }
    this.searchDmsDocumentsVwDetails = {

      documentId: this.searchByDocumentId,
      documentName: this.searchByDocumetnName,
      documentType: this.documentTypeValue,
    };
    this.appService.searchDocuments(this.searchDmsDocumentsVwDetails).subscribe((response: any) => {
      this.getDmsDocumentsVwDetailsTableData = response;
      this.showDocumentsSearchGrid = true;
      this.isProcessing = false;
      //console.log(this.getOneQmsUsersVwDetailsTableData);
    })
  }

  resetSearchDocumentGridDataFunction() {
    this.isProcessing = true;
    this.searchByDocumentId = null;
    this.searchByDocumetnName = null;
    this.documentTypeValue = "";
    this.showDocumentsSearchGrid = false;
    this.isProcessing = false;
  }

  onSearchDocTypeSelect(item: any) {
    this.documentTypeValue = item.valueExp;
  }

  onSearchDocTypeRemoved(item: any) {
    this.documentTypeValue = "";
  }

  documentName: any;
  documentType: any;
  belongsToUser: any;
  description: any;
  crFeild: any;
  documentNameRequiredMsg: any;
  documentTypeRequiredMsg: any;
  belongsToUserRequiredMsg: any;
  descriptionRequiredMsg: any;
  crFieldRequiredMsg: any;
  revisionHistory: any;
  revisionHistoryRequiredMsg: any;
  fieldValidation() {
    this.documentName = document.getElementById('documentName') as HTMLInputElement;
    this.documentType = document.getElementById('documentType') as HTMLInputElement;
    this.belongsToUser = document.getElementById('documentName') as HTMLInputElement;
    this.description = document.getElementById('description') as HTMLInputElement;
    this.crFeild = document.getElementById('cr') as HTMLInputElement;

    this.documentNameRequiredMsg = document.getElementById('documentName-required-msg') as HTMLInputElement;
    this.documentTypeRequiredMsg = document.getElementById('documentType-required-msg') as HTMLInputElement;
    this.belongsToUserRequiredMsg = document.getElementById('belongsToUser-required-msg') as HTMLInputElement;
    this.descriptionRequiredMsg = document.getElementById('description-required-msg') as HTMLInputElement;
    this.crFieldRequiredMsg = document.getElementById('cr-required-msg') as HTMLInputElement;

    if (this.documentData.documentName == "") {
      this.documentName.style.border = '1px solid red';
      this.documentNameRequiredMsg.style.display = 'block';
    } else {
      this.documentName.style.border = 'none';
      this.documentNameRequiredMsg.style.display = 'none';
    }

    if (!this.documentData.documentDescription || String(this.documentData.documentDescription).trim() === '') {
      this.description.style.border = '1px solid red';
      this.descriptionRequiredMsg.style.display = 'block';
    } else {
      this.description.style.border = 'none';
      this.descriptionRequiredMsg.style.display = 'none';
    }



    if (this.selectedDocumentTypeValue == "") {
      this.documentType.style.border = '1px solid red';
      this.documentTypeRequiredMsg.style.display = 'block';
    } else {
      this.documentType.style.border = 'none';
      this.documentTypeRequiredMsg.style.display = 'none';
    }

    if (this.isCrFeildIsMandatory) {
      if (this.documentData.crNo == null) {
        this.crFeild.style.border = '1px solid red';
        this.crFieldRequiredMsg.style.display = 'block';
      } else {
        this.crFeild.style.border = 'none';
        this.crFieldRequiredMsg.style.display = 'none';
      }
    }
    if (this.isShowUserBelongsToField) {
      if (this.documentData.belongsUserId == null) {
        this.belongsToUser.style.border = '1px solid red';
        this.belongsToUserRequiredMsg.style.display = 'block';
      } else {
        this.belongsToUser.style.border = 'none';
        this.belongsToUserRequiredMsg.style.display = 'none';
      }
    }

  }

  revisionHistoryfieldValidation() {
    this.revisionHistory = document.getElementById('revisionHistory') as HTMLInputElement;
    this.revisionHistoryRequiredMsg = document.getElementById('revisionHistory-required-msg') as HTMLInputElement;
    if (this.documentData.revisionHistory == null) {
      this.revisionHistory.style.border = '1px solid red';
      this.revisionHistoryRequiredMsg.style.display = 'block';
    } else {
      this.revisionHistory.style.border = 'none';
      this.revisionHistoryRequiredMsg.style.display = 'none';
    }
  }

  config: EditorConfig = {
    placeholder: '',
    buttons: ST_BUTTONS,

  };

  config1: EditorConfig = {
    placeholder: '',
    buttons: [],
  };

  back() {
    history.back();
  }

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  isDocumentSaved: boolean = false;
  saveDocResponse: any;
  saveDocument(value: any) {
    this.isProcessing = true;
    this.isMandatoryField = false;
    this.onclickedSaveButton = true;
    for (let i = 0; i < this.flexiFieldsList.length; i++) {
      // 1. Logic for Checkboxes
      if (this.flexiFieldsList[i].isMandatory == 'Y' &&
        (this.flexiFieldsList[i].fieldType == 'Horizontal Checkbox Button' ||
          this.flexiFieldsList[i].fieldType == 'Vertical Checkbox Button') &&
        this.flexiFieldsList[i].checkedCheckBoxValue.length == 0) {
        this.isMandatoryField = true;
      }
      //Logic for Multiselect Drop Down (Check selectedFlexifieldValue array length)
      else if (this.flexiFieldsList[i].isMandatory == 'Y' &&
        this.flexiFieldsList[i].fieldType == 'Multiselect Drop Down' &&
        (this.flexiFieldsList[i].selectedFlexifieldValue == null ||
          this.flexiFieldsList[i].selectedFlexifieldValue.length == 0)) {
        this.isMandatoryField = true;
      }
      // 3. Logic for others (Text, Date, Single Dropdown, Large Text)
      else if ((this.flexiFieldsList[i].fieldType != 'Horizontal Checkbox Button' &&
        this.flexiFieldsList[i].fieldType != 'Vertical Checkbox Button' &&
        this.flexiFieldsList[i].fieldType != 'Multiselect Drop Down') &&
        (this.flexiFieldsList[i].fieldDefaultValue == null || String(this.flexiFieldsList[i].fieldDefaultValue).trim() === '') && this.flexiFieldsList[i].isMandatory == 'Y') {
        this.isMandatoryField = true;
      }
    }
    this.isProcessing = true;
    if (this.documentData['documentName'] == "" || this.selectedDocumentTypeValue == "" || !this.documentData['documentDescription'] || String(this.documentData['documentDescription']).trim() === ''
      || (this.isShowUserBelongsToField && this.documentData.belongsUserId == null) || (this.isCrFeildIsMandatory && this.documentData.crNo == null)
      || (this.documentData.version == "" && this.isVersionManually) || (this.documentData.documentNo == "" && this.isDocumentNoManually)) {
      if (this.buttonLabel == "CheckIn") {
        this.selectedTabIndex = 0;
        this.isProcessing = false;
        this.warningMsg = "Please enter all mandatory fields!";
        this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
      } else {
        this.selectedTabIndex = 0;
        this.isProcessing = false;
      }

    } else if (this.documentData['revisionHistory'] == null || String(this.documentData['revisionHistory']).replace(/<[^>]*>?/gm, '').trim() === "") {
      if (this.buttonLabel == "CheckIn") {
        this.selectedTabIndex = 1;
        this.isProcessing = false;
        this.warningMsg = "Please enter all mandatory fields!";
        this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
      } else {

        this.selectedTabIndex = 1;
        this.isProcessing = false;
      }

    } else if (this.isMandatoryField) {
      this.selectedTabIndex = 2;
      this.isProcessing = false;

    } else if (this.isBeforeSaveUploadDiffFile && !this.isFileValid) {
      this.warningMsg = "Please select and upload a new file before saving.";
      this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
      this.isProcessing = false;
      return
    } else if (this.operationFlag == "ADD" &&
      (this.uploadFilePath == null || this.uploadFilePath == undefined) &&
      (this.documentData.document == null || this.documentData.document == undefined)) {
      this.warningMsg = "Please provide the document."
      this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
      this.isProcessing = false;
    } else {
      if (this.operationFlag == "ADD") {
        this.documentData.documentTypeCode = this.selectedDocumentTypeValue;
        this.documentData.isBlinded = this.documentData.isBlinded1 ? "Y" : "N";
        this.documentData.folderId = this.parentFolderId;
        this.documentData.docOrPlaceholder = "DOCUMENT";
        if (this.documentData.effectiveDate != null) {
          const effectiveDateValue = new Date(this.documentData.effectiveDate);
          this.documentData.effectiveDate = this.appService.dateZoneConvertion(effectiveDateValue);
        }
        if (this.documentData.expirationDate != null) {
          const expirationDateValue = new Date(this.documentData.expirationDate);
          this.documentData.expirationDate = this.appService.dateZoneConvertion(expirationDateValue);
        }
        if (this.uploadFilePath != null && this.uploadFilePath != undefined) {
          // For uploaded files
          this.documentData.uploadFolderPath = this.uploadFilePath + "." + this.uploadFilePathextension;
        } else if (this.documentData.document != null) {
          // For templates, don't set uploadFolderPath as content is already in documentData.document
          this.documentData.uploadFolderPath = null;
        }
        const formData = new FormData();
        //  formData.append('file', this.document);
        const json = JSON.stringify(this.documentData);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('dmsDocumentDto', blob);
        this.isProcessing = true;
        this.appService.createDmsDocument(formData).subscribe((Response: any) => {
          this.isProcessing = false;
          this.isFileChanged = false;
          if (Response.resultType == "S") {
            let documentId = Response.documentId;
            this.isDocumentSaved = true;
            this.appService.getDocumentByDocIdFirstTime(
              documentId).subscribe((data: any) => {
                this.patchDocumentData(data[0]);
                this.documentData['saveButtonForDocument'] = false;
                this.isBeforeSaveUploadDiffFile = false;
                if (this.flexiFieldsList.length > 0) {
                  this.saveFlexifieldData(value);
                } else {
                  this.getInitialCall();
                }

              }, (error) => {
                this.isProcessing = false;
              });

          } else {
            // this.displayMsg = false;
            // this.resultMsg = data.result;
            // this.dangerMsg = true;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      } else {

        this.documentData.documentTypeCode = this.selectedDocumentTypeValue;
        this.documentData.isBlinded = this.documentData.isBlinded1 ? "Y" : "N";
        this.documentData.folderId = this.parentFolderId;
        if (this.documentData.effectiveDate != null) {
          const effectiveDateValue = new Date(this.documentData.effectiveDate);
          this.documentData.effectiveDate = this.appService.dateZoneConvertion(effectiveDateValue);
        }
        if (this.documentData.expirationDate != null) {
          const expirationDateValue = new Date(this.documentData.expirationDate);
          this.documentData.expirationDate = this.appService.dateZoneConvertion(expirationDateValue);
        }
        if (!this.isFileChanged && !this.isBeforeSaveUploadDiffFile) {
          this.documentData.documentExtn = null;
        }
        const formData = new FormData();
        formData.append('file', this.document ? this.document : '');
        const json = JSON.stringify(this.documentData);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('dmsDocumentDto', blob);
        this.isProcessing = true;
        this.appService.updateDmsDocument(formData).subscribe((Response: any) => {
          this.isProcessing = false;
          this.isFileChanged = false;
          if (value == 'CheckIn') {
            if (Response.resultType == "S") {
              this.isDocumentSaved = true;
              if (this.documentData.version == 0) {
                this.appService.getDocumentByDocIdFirstTime(
                  this.documentData.documentId).subscribe((data: any) => {
                    this.documentData = data[0];
                    this.documentData['saveButtonForDocument'] = false;
                    this.isBeforeSaveUploadDiffFile = false;
                    if (this.flexiFieldsList.length > 0) {
                      this.saveFlexifieldData(value);
                    } else {
                      this.getInitialCall();
                    }

                    if (value == 'CheckIn' && this.documentData.onlineEditorMode == null) {
                      this.performCommonOperation();
                    } else {
                      this.pullTheDocumentInserver1();
                    }

                  }, (error) => {
                    this.isProcessing = false;
                  });
              } else {
                this.isBeforeSaveUploadDiffFile = false;
                if (this.flexiFieldsList.length > 0) {
                  this.saveFlexifieldData(value);
                } else {
                  this.appService.getDocumentByDocumentId(
                    this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
                      this.documentData = data[0];
                      this.documentData['saveButtonForDocument'] = false;
                      this.isProcessing = false;
                      this.getInitialCall()
                    }, (error) => {
                      this.isProcessing = false;
                    });
                }

                if (value == 'CheckIn' && this.documentData.onlineEditorMode == null) {
                  this.performCommonOperation();
                } else {
                  this.pullTheDocumentInserver1();
                }
              }

            } else {
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }

            this.isProcessing = false;
          } else {
            if (Response.resultType == "S") {
              this.isDocumentSaved = true;
              if (this.documentData.version == 0) {
                this.appService.getDocumentByDocIdFirstTime(
                  this.documentData.documentId).subscribe((data: any) => {
                    this.documentData = data[0];
                    this.documentData['saveButtonForDocument'] = false;
                    this.isBeforeSaveUploadDiffFile = false;
                    if (this.flexiFieldsList.length > 0) {
                      this.saveFlexifieldData(value);
                    } else {
                      this.getInitialCall();
                    }

                    if (value == 'CheckIn') {
                      this.performCommonOperation();
                    }

                  }, (error) => {
                    this.isProcessing = false;
                  });
              } else {
                this.isBeforeSaveUploadDiffFile = false;
                if (this.flexiFieldsList.length > 0) {
                  this.saveFlexifieldData(value);
                } else {
                  this.appService.getDocumentByDocumentId(
                    this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
                      this.documentData = data[0];
                      this.documentData['saveButtonForDocument'] = false;
                      this.isProcessing = false;
                      this.getInitialCall()
                    }, (error) => {
                      this.isProcessing = false;
                    });
                }

                if (value == 'CheckIn') {
                  this.performCommonOperation();
                }
              }
            }
            if (this.flexiFieldsList.length == 0) {
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
              this.isProcessing = false;
            } else {
              this.saveDocResponse = Response;
            }
          }
          if (!this.isCoverpageEnable) {
            console.log("isCoverpageEnable");
            this.loadDataInViewer(this.document, null, this.viewer);
          } else {
            console.log("isCoverpageEnable1")
          }

        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      }

    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }
  pullTheDocumentInserver1() {

    this.handleButtonClick(this.message.tenantId, this.message.clientId, "pullTheDocumentInserver");

  }

  varifyThefile() {

    this.isProcessing = true;
    const formData = new FormData();
    //   formData.append('file', this.document.body);
    formData.append('documentId', this.documentData.documentId);
    formData.append('accessToken', this.documentData.version);
    formData.append('docVersion', this.documentData.version);

    let data = {

      documentId: this.documentData['documentId'],
      version: this.documentData['version'],
      accessToken: this.accessToken,
      stageName: this.stageName,
      buttonValue: this.buttonLabel,
      hostname: this.message.hostName,  //"clinevo.sharepoint.com"
      sitePath: this.message.sitePath,//"
      actionStatus: this.selectedStatusValue,
      comments: this.comments,
      rejectReason: this.selectedRejectReasonValue,
      reasonForSignature: this.selectedReasonValue,
      documentExtn: this.documentData.documentExtn
      //  coAuthorList: this.selectedUser?.toString(),
    }

    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    formData.append('dmsDocumentsOnlineDto', blob);


    this.appService.varifyOnliedoc(formData).subscribe((data1: any) => {
      this.documentData.onlineEditorMode = null;
      this.isShowViewer = true;
      this.loadDataInViewer(data1, this.documentData.documentExtn, this.viewer);
      this.isProcessing = false;
    })


    // throw new Error('Method not implemented.');
  }


  pullTheDocumentInserver() {


    this.isProcessing = true;
    const formData = new FormData();
    //   formData.append('file', this.document.body);
    formData.append('documentId', this.documentData.documentId);
    formData.append('accessToken', this.documentData.version);
    formData.append('docVersion', this.documentData.version);

    let data = {
      documentId: this.documentData['documentId'],
      version: this.documentData['version'],
      accessToken: this.accessToken,
      stageName: this.stageName,
      buttonValue: this.buttonLabel,
      hostname: this.message.hostName,  //"clinevo.sharepoint.com"
      sitePath: this.message.sitePath,//"
      actionStatus: this.selectedStatusValue,
      comments: this.comments,
      rejectReason: this.selectedRejectReasonValue,
      reasonForSignature: this.selectedReasonValue,
      documentExtn: this.documentData.documentExtn
      //  coAuthorList: this.selectedUser?.toString(),
    }

    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    formData.append('dmsDocumentsOnlineDto', blob);



    this.appService.performonlieneditcheckin(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      //   this.visibleConfirm.close();
      if (Response.resultType == "S") {
        this.performCommonOperation();
        this.isProcessing = true;
        this.appService.getDocumentByDocumentId(
          this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
            this.documentData = data[0];
            this.documentData['saveButtonForDocument'] = false;
            this.isProcessing = false;
            this.getInitialCall()
          })


      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })


    // throw new Error('Method not implemented.');
  }

  downloadDocument() {
    this.appService.getDocumentsToViewForDms(
      this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
        const blob = new Blob([data.body]);
        let url = URL.createObjectURL(blob);
        const contentData = url;

        let downloadLink = document.createElement("a");
        downloadLink.href = contentData;

        downloadLink.download = this.documentData.documentName + "." + this.documentData['documentExtn'];
        downloadLink.click();
      })
  }

  makeVariable(data: any) {
    let splittedData = data.mappingColumn.toLowerCase().split("_");
    for (let j = 1; j < splittedData.length; j++) {
      splittedData[j] = splittedData[j].charAt(0).toUpperCase() + splittedData[j].slice(1);
    }
    let finalvariable = splittedData.join('');
    return finalvariable;
  }

  checkBoxChecked(data: any, event: any, val: any) {
    if (event.checked) {
      data.checkedCheckBoxValue.push(val);
    } else {
      let index = data.checkedCheckBoxValue.indexOf(val);
      data.checkedCheckBoxValue.splice(index, 1);
    }
  }

  mandatoryCheck() {
    for (let i = 0; i < this.flexiFieldsList.length; i++) {
      if (this.flexiFieldsList[i].mappingColumn != null) {
        let finalVariable = this.makeVariable(this.flexiFieldsList[i]);
        if (this.flexiFieldsList[i].fieldType == "Horizontal Checkbox Button" || this.flexiFieldsList[i].fieldType == "Vertical Checkbox Button") {
          this.flexiFieldsList[i].fieldDefaultValue = null;
          for (let k = 0; k < this.flexiFieldsList[i].checkedCheckBoxValue.length; k++) {
            if (this.flexiFieldsList[i].fieldDefaultValue == null) {
              this.flexiFieldsList[i].fieldDefaultValue = this.flexiFieldsList[i].checkedCheckBoxValue[k];
            } else {
              this.flexiFieldsList[i].fieldDefaultValue = this.flexiFieldsList[i].fieldDefaultValue + "," + this.flexiFieldsList[i].checkedCheckBoxValue[k];
            }
          }

        }
      } else {

      }
      if ((this.flexiFieldsList[i].fieldDefaultValue == null || String(this.flexiFieldsList[i].fieldDefaultValue).trim() === '') && this.flexiFieldsList[i].isMandatory == 'Y') {
        this.isMandatoryField = true;
      }
    }
    if (this.isMandatoryField) {
      this.isProcessing = false;
      this.flexifieldValidation();
    }
  }

  isMandatoryField = false;
  saveFlexifieldData(value: any) {
    this.isProcessing = true;
    let obj: any = {

      refId: this.documentData['documentId'],
      version: this.documentData['version'],

    }
    for (let i = 0; i < this.flexiFieldsList.length; i++) {
      if (this.flexiFieldsList[i].mappingColumn != null) {
        let finalVariable = this.makeVariable(this.flexiFieldsList[i]);

        // 1. EXISTING CHECKBOX LOGIC (Kept as is)
        if (this.flexiFieldsList[i].fieldType == "Horizontal Checkbox Button" ||
          this.flexiFieldsList[i].fieldType == "Vertical Checkbox Button") {

          this.flexiFieldsList[i].fieldDefaultValue = null;

          for (let k = 0; k < this.flexiFieldsList[i].checkedCheckBoxValue.length; k++) {
            if (this.flexiFieldsList[i].fieldDefaultValue == null) {
              this.flexiFieldsList[i].fieldDefaultValue = this.flexiFieldsList[i].checkedCheckBoxValue[k];
            } else {
              // Your existing concatenation logic
              this.flexiFieldsList[i].fieldDefaultValue = this.flexiFieldsList[i].fieldDefaultValue + "," + this.flexiFieldsList[i].checkedCheckBoxValue[k];
            }
          }
        }
        // 2. NEW MULTISELECT LOGIC (Added here)
        else if (this.flexiFieldsList[i].fieldType == "Multiselect Drop Down") {
          if (this.flexiFieldsList[i].selectedFlexifieldValue && this.flexiFieldsList[i].selectedFlexifieldValue.length > 0) {
            this.flexiFieldsList[i].fieldDefaultValue = this.flexiFieldsList[i].selectedFlexifieldValue.join(",");
          } else {
            this.flexiFieldsList[i].fieldDefaultValue = null;
          }
        }

        obj[finalVariable] = this.flexiFieldsList[i].fieldDefaultValue;
      }

      if (this.flexiFieldsList[i].fieldType == "Multiselect Drop Down") {
        if ((this.flexiFieldsList[i].selectedFlexifieldValue == null || this.flexiFieldsList[i].selectedFlexifieldValue.length === 0)
          && this.flexiFieldsList[i].isMandatory == 'Y') {
          this.isMandatoryField = true;
        }
      } else {
        if ((this.flexiFieldsList[i].fieldDefaultValue == null || String(this.flexiFieldsList[i].fieldDefaultValue).trim() === '') && this.flexiFieldsList[i].isMandatory == 'Y') {
          this.isMandatoryField = true;
        }
      }
    }
    if (this.flexifieldObj['recordId'] != null) {
      obj.recordId = this.flexifieldObj['recordId'];
      this.appService.updateFlexifieldData(obj).subscribe((data: any) => {
        this.isProcessing = true;
        this.appService.getDocumentByDocumentId(
          this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
            this.documentData = data[0];
            this.documentData['saveButtonForDocument'] = false;
            this.isProcessing = false;
            this.getInitialCall()
          })
        if (value == "CheckIn") {
          if (data.resultType == "S") {
            this.isProcessing = false;
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: this.saveDocResponse.result + ' ' + data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }

        } else {
          if (data.resultType == "S") {
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: this.saveDocResponse.result + ' ' + data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }

        this.isProcessing = false;
      })
    } else {
      this.appService.addFlexifieldData(obj).subscribe((data: any) => {
        this.isProcessing = true;
        this.appService.getDocumentByDocumentId(
          this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
            this.patchDocumentData(data[0]);
            this.documentData['saveButtonForDocument'] = false;
            this.isProcessing = false;
            this.getInitialCall()
          })
        if (value == "CheckIn") {
          if (data.resultType == "S") {
            this.isProcessing = false;
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: this.saveDocResponse.result + ' ' + data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }

        } else {
          if (data.resultType == "S") {
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: this.saveDocResponse.result + ' ' + data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }
        this.isProcessing = false;
      })
    }
    //}

  }

  flexifield: any;
  flexifieldNameRequiredMsg: any;
  flexifieldValidation() {

    for (let i = 0; i < this.flexiFieldsList.length; i++) {
      this.flexifield = document.getElementById('flexifield' + i) as HTMLInputElement;
      this.flexifieldNameRequiredMsg = document.getElementById('flexifield' + i + '-required-msg') as HTMLInputElement;

      if ((this.flexiFieldsList[i].fieldDefaultValue == null || String(this.flexiFieldsList[i].fieldDefaultValue).trim() === '') && this.flexiFieldsList[i].isMandatory == 'Y') {
        this.flexifield.style.border = '1px solid red';
        this.flexifieldNameRequiredMsg.style.display = 'block';
      } else {
        this.flexifield.style.border = '';
        this.flexifieldNameRequiredMsg.style.display = 'none';
      }


      if (this.flexiFieldsList[i].fieldType == 'Multiselect Drop Down') {
        if ((this.flexiFieldsList[i].selectedFlexifieldValue == null || this.flexiFieldsList[i].selectedFlexifieldValue.length == 0) &&
          this.flexiFieldsList[i].isMandatory == 'Y') {
          this.flexifield.style.border = '1px solid red';
          this.flexifieldNameRequiredMsg.style.display = 'block';
        } else {
          this.flexifield.style.border = '';
          this.flexifieldNameRequiredMsg.style.display = 'none';
        }
      }
    }
  }

  reason: any;
  title: any;
  buttonLabel: any;

  isEsignRequired = false;
  isReasonSignReqd = false;
  userName: any;
  password: any = "";
  actionStatus: any;
  comments: any;
  rejectReason: any;
  isConfirmationFileValid = false;
  statusList: any = [];
  rejectReasonList: any = [];
  reasonForSignatureList: any = [];
  moduleStage: any;
  trainingList: any = [];
  selectedTrainingIds: any = [];
  selectedTrainingId: any;
  userDropdown: any = [];
  selectedUser: any;
  dynamicButtonClick(button: string) {
    this.reason = "";
    this.buttonLabel = button;
    this.checkoutDocList = [];
    // this.checkoutDocList=null;
    if (button == "Publish") {
      if (this.documentData['effectiveDate'] != null) {
        this.documentData.effectiveDate = new Date(this.documentData['effectiveDate']);
      } else {
        this.documentData.effectiveDate = new Date();
      }
      if (this.documentData['expirationDate'] != null) {
        this.documentData.expirationDate = new Date(this.documentData['expirationDate']);
      } else {
        if (this.documentTypeData.expiryInUnit != null) {
          this.selectExpValue(new Date(this.documentData.effectiveDate));
        }
      }

      this.trainingList = [];
      this.selectedTrainingIds = [];
      this.selectedTrainingId = null;
      this.isProcessing = true;
      let obj = {
        documentId: this.documentData.documentId,
        documentVersion: this.documentData.version
      }
      this.appService.getContentsBasedOnDocId(obj).subscribe((data: any) => {
        this.isProcessing = false;
        for (let i = 0; i < data.length; i++) {
          let obj = { "trainingId": data[i].trainingId, "version": data[i].version };
          if (this.trainingList.indexOf(obj) == -1) {
            this.trainingList.push(obj);
            this.selectedTrainingIds.push(obj.trainingId);
          }

        }
        if (this.trainingList.length > 0) {
          //this.publishPopupConfig.width="75%";
          this.selectedTrainingId = this.selectedTrainingIds.join(",");
          this.newRun("tr", this.selectedTrainingId);
        } else {
          //this.publishPopupConfig.width="40%";
        }
      })

      this.title = button;
      this.reason = "";
      this.changetypeAddAndEditPassword = true;
      this.visiblPublishPopup = this.dialog.open(this.publishPopup, this.publishPopupConfig);
    } else if (button == "Collaborative Review" || button == "Change Collaborative Reviewers") {
      this.title = button;
      this.userDropdown = [];
      this.selectedUser = [];
      this.isProcessing = true;
      this.appService.getUserListOfDocForStageUser("Reviewer", this.documentData.folderId, this.documentData['isBlinded']).subscribe((data: any) => {
        this.isProcessing = false;
        this.userDropdown = [];
        for (let i = 0; i < data.length; i++) {
          this.userDropdown = this.userDropdown.concat({
            valueExp: data[i].userOrRoleId,
            displayExp: data[i].userOrRoleName
          });
        }
        this.isProcessing = true;
        this.appService.getUserListOfDocForStageUser("Approver", this.documentData.folderId, this.documentData['isBlinded']).subscribe((data1: any) => {
          this.isProcessing = false;
          for (let i = 0; i < data1.length; i++) {
            if (this.userDropdown.findIndex((user: any) => user.valueExp === data1[i].userOrRoleId) == -1) {
              this.userDropdown = this.userDropdown.concat({
                valueExp: data1[i].userOrRoleId,
                displayExp: data1[i].userOrRoleName
              });
            }

          }
          // Use corevivwerList if present, else collaborativeReviewers
          let reviewersString = this.documentData.corevivwerList || this.documentData.collaborativeReviewers;
          if (reviewersString != null) {
            let creviewers = reviewersString.split(",").map((id: any) => id.trim());
            this.selectedUser = creviewers.filter((reviewerId: any) =>
              this.userDropdown.some((user: any) => String(user.valueExp) === String(reviewerId))
            );
          }


        })

      })
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    } else if (button == "Change Co-Authors") {
      this.userDropdown = [];
      this.selectedUser = [];
      this.isProcessing = true;
      this.appService.getUserListOfDocForStageUser("Author", this.documentData.folderId, this.documentData['isBlinded']).subscribe((data: any) => {
        this.isProcessing = false;
        this.userDropdown = [];
        for (let i = 0; i < data.length; i++) {
          this.userDropdown = this.userDropdown.concat({
            valueExp: data[i].userOrRoleId,
            displayExp: data[i].userOrRoleName
          });
        }
        if (this.documentData.coauthors != null) {
          let coauthors = this.documentData.coauthors.split(",").map((id: any) => id.trim());
          // Ensure all valueExp are strings for comparison
          this.selectedUser = coauthors.filter((coauthorId: any) =>
            this.userDropdown.some((user: any) => String(user.valueExp) === String(coauthorId))
          );
        }
      })
      this.visibleConfirmCoauthor = this.dialog.open(this.confirmPopupCoauthor, this.confirmWithReasonPopupConfig);
    }
    else if (
      button === "Delete" ||
      button === "Activate" ||
      button === "Update" ||
      button === "Submit for Review" ||
      button === "Submit for Approval" ||
      button === "Self Lock" ||
      button === "CheckOut" ||
      button === "CheckIn" ||
      button === "Submit for Signoff"
    ) {
      this.title = button;
      this.reason = "";
      this.checkoutcrId = null;
      this.checkoutcrNo = null;

      // Handle CheckOut / CheckIn logic
      if (button === "CheckOut" || button === "CheckIn") {
        this.reason = this.documentData.checkinoutComments;
        if (this.documentData.status !== 'Published') {
          this.checkoutcrId = this.documentData.crDetails;
          this.checkoutcrNo = this.documentData.crNo;
        }
      }

      // Handle Delete logic with async API call
      if (button === "Delete") {
        this.isProcessing = true;
        this.isParentDocument = false;
        this.appService
          .getAssociatedDocumentsDetail(
            this.documentData.documentId,
            this.documentData.version
          )
          .subscribe(
            (data: any) => {
              this.isProcessing = false;
              if (Array.isArray(data) && data.length > 0) {
                this.isParentDocument = true;
                console.log("Document is a parent. Found", data.length, "associated child documents.");
              } else {
                console.log("No associated children found.");
              }

              // ✅ Open popup only once after API call completes
              this.visibleConfirmWithReason = this.dialog.open(
                this.confirmWithReasonPopup,
                this.confirmWithReasonPopupConfig
              );
            },
            (error) => {
              this.isProcessing = false;
              console.error("Error checking associated documents:", error);
              this.isParentDocument = false;

              // ✅ Open popup once even on error
              this.visibleConfirmWithReason = this.dialog.open(
                this.confirmWithReasonPopup,
                this.confirmWithReasonPopupConfig
              );
            }
          );
      }
      // For all other button actions (non-Delete)
      else {
        this.visibleConfirmWithReason = this.dialog.open(
          this.confirmWithReasonPopup,
          this.confirmWithReasonPopupConfig
        );
      }

      // Handle special case for CheckOut
      if (button === "CheckOut") {
        if (this.document.status?.toLowerCase().includes('pending') || this.document.status?.toLowerCase().includes('inprogress')) {
          this.warningMsg = `The document is in ${this.document.status}, do you really want to check out?`;
          this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
        }
      }
    }
    else if (button == "Review" || button == "Approve" || button == "Signoff") {
      this.password = "";
      this.comments = "";
      this.statusDropdown = [];
      this.rejectReasonDropdown = [];
      this.userName = localStorage.getItem("loggedUserName");
      this.selectedReason = null;
      this.selectedStatus = [];
      this.selectedRejectReason = null;
      this.selectedReasonValue = "";
      this.selectedStatusValue = "";
      this.selectedRejectReasonValue = "";
      this.reasonDropdown = [];
      this.statusList = [];
      let data1 = [];
      if (this.actionStatusOptions != null) {
        data1 = this.actionStatusOptions.split(",");
      }
      for (let i = 0; i < data1.length; i++) {
        let data2 = data1[i].split("/");
        if (data2.length > 1) {
          this.statusList.push({ codelistCode: data2[1].trim(), codelistName: data2[0].trim() });
        } else {
          this.statusList.push({ codelistCode: data2[0].trim(), codelistName: data2[0].trim() });
        }

      }
      for (let i = 0; i < this.statusList.length; i++) {
        this.statusDropdown = this.statusDropdown.concat({
          valueExp: this.statusList[i].codelistCode,
          displayExp: this.statusList[i].codelistName
        });
      }
      this.isProcessing = true;
      this.appService.getCodeListsByGroup("DOCUMENT_REJECT_REASON").subscribe((data: any) => {
        this.rejectReasonList = data;
        this.isProcessing = false;
        for (let i = 0; i < this.rejectReasonList.length; i++) {
          this.rejectReasonDropdown = this.rejectReasonDropdown.concat({
            valueExp: this.rejectReasonList[i].codelistCode,
            displayExp: this.rejectReasonList[i].codelistName
          });
        }
      })
      this.isProcessing = true;
      this.appService.getModuleStages("DOCS", this.buttonLabel)
        .subscribe((data: any) => {
          this.isProcessing = false;

          if (data.length > 0) {
            this.moduleStage = data[0];
            if (data[0].esignReqd == "Y") {
              this.isEsignRequired = true;
            }
            if (data[0].reasonForSignatureReqd == "Y") {
              this.isReasonSignReqd = true;
            }
          }
        })
      this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
    } else if (button == "Download") {
      this.title = "Download";
      this.visibleSDownloadPopup = this.dialog.open(this.downloadPopup, this.propertiesdownloadPopupConfig);
    } else {
      this.isProcessing = true;
      this.isParentDocument = false;

      this.appService
        .getAssociatedDocumentsDetail(
          this.documentData.documentId,
          this.documentData.version
        )
        .subscribe(
          (data: any) => {
            this.isProcessing = false;
            if (Array.isArray(data) && data.length > 0) {
              this.isParentDocument = true;
              console.log("Document is a parent. Found", data.length, "associated child documents.");
            } else {
              console.log("No associated children found.");
            }
            this.title = button;
            this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
          });

    }

  }

  handleDropDownValidation(fieldId: string, selectedItems: [] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'execution-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    if (field) {
      field.style.color = shouldBeRed ? 'red' : '#005c8a';
    }

  }

  onUsersSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        setTimeout(() => { this.isAllUsersSelected = this.userDropdown.length == this.selectedUser.length; })
        this.handleDropDownValidation('execution-validation', this.selectedUser)
      });

  }
  userSearchText: string = '';
  @ViewChild('userFeild') userFeild: MatSelect;
  isAllUsersSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'userFeild') {
      if (this.isAllUsersSelected) this.userFeild.options.forEach((item: MatOption) => item.select());
      else {
        this.userFeild.options.forEach((item: MatOption) => item.deselect())
        this.selectedUser = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execution-validation', this.selectedUser)
      });
    }
  }

  okPublishFunc() {
    if (this.getOneQmsUsersTrainingsRepVwDetails.length > 0) {
      this.visiblPublishConfirmPopup = this.dialog.open(this.publishConfirmPopup, this.publishConfirmPopupConfig);
    } else {
      this.confirmWithReasonFunc();
    }
  }

  cancelConfirmPublishFunc() {
    this.visiblPublishConfirmPopup.close();
  }

  cancelPublishFunc() {
    this.visiblPublishPopup.close();
  }
  totalVal = 0;
  yetToBeAttemptedVal = 0;
  attemptedVal = 0;
  completedAtAttemptedVal = 0;
  failedAtAttemptedChartVal = 0;
  scheduledAtAttemptedChartVal = 0;
  passPerValForAll: any = 0;
  inprogressVal = 0;
  passedVal = 0;
  failedVal = 0;
  scheduledVal = 0;
  passPerVal: any = 0;
  lockedVal = 0;
  completedVal = 0;
  notCompletedVal = 0;
  overdueVal = 0;
  pendingVal = 0;
  lockedOverdueVal = 0;
  chartOptionsForUser: any;
  dropDownForCategories: any = [];
  getTmsInstructorTrainerData: any = [];
  dropDownForLangauge: any = [];
  groupdataList: any = [];
  dropDownForOrg: any = [];
  cards: any = [];
  labels: any = [];
  icons: any
  selectedOverDue: any = [];
  dropDownForOverDue: any = [];
  overDueDropDown: any = [];
  type: any;
  repType: any;
  duedate: any;
  retakeDuedateValue: any;
  popupVal: any;
  dateRangeValueDropdown: any = [];
  childGridShow: any;
  getOneQmsUsersTrainingsRepVwDetails: any = [];
  getOneQmsUsersTrainingsRepVw: any = [];
  afterClickGenrate: boolean = false;
  notCompleted: boolean = false;
  itemsPerPage = 5;
  currentPage4th = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  pager: any = {};
  calculateTotalPages: number;
  newRun(type: any, val: any) {

    this.getOneQmsUsersTrainingsRepVw = [];
    this.isProcessing = true;
    let i = 0;
    this.afterClickGenrate = false;
    this.totalVal = 0;
    this.attemptedVal = 0;
    this.yetToBeAttemptedVal = 0;
    this.completedAtAttemptedVal = 0;
    this.failedAtAttemptedChartVal = 0;
    this.scheduledAtAttemptedChartVal = 0;
    this.passPerValForAll = 0;
    this.inprogressVal = 0;
    this.passedVal = 0;
    this.failedVal = 0;
    this.scheduledVal = 0;
    this.lockedVal = 0;
    this.completedVal = 0;
    this.overdueVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    let attaptedVal = "";

    if (this.message.showRetakeAndMarkasCompleted) {
      attaptedVal = "noNeedConsiderForReport"
    } else {
      attaptedVal = "NeedConsiderForReport"
    }
    this.appService.getOneQmsUserTrainingsRepVwMain(type, val, attaptedVal).subscribe((data: any) => {
      this.afterClickGenrate = true;
      this.getOneQmsUsersTrainingsRepVwDetails = data;
      this.calculateTotalPages = this.collectionSize / this.perPage;
      this.pager.totalPages = undefined;
      this.collectionSize = this.getOneQmsUsersTrainingsRepVwDetails.length;
      this.totalPages = Math.ceil(this.getOneQmsUsersTrainingsRepVwDetails.length / this.itemsPerPage);
      this.setPageMain(1, 0);
      data.forEach((item: any, index: any) => {
        this.totalVal += item.total;
        this.attemptedVal += item.attempted;
        this.completedAtAttemptedVal += item.completedAtAttemptedChart;
        this.failedAtAttemptedChartVal += item.failedAtAttemptedChart;
        this.scheduledAtAttemptedChartVal += item.scheduledAtAttemptedChart;
        this.yetToBeAttemptedVal += item.yetToBeAttempted;
        this.passPerValForAll = (this.completedAtAttemptedVal / this.totalVal * 100).toFixed(1);
        this.pendingVal += item.pending;
        this.inprogressVal += item.inprogress;
        this.failedVal += item.failed;
        this.scheduledVal += item.scheduled;
        this.completedVal += item.completed;
        this.overdueVal += item.overdue;
        this.lockedVal += item.locked;
        this.passPerVal = (this.completedVal / this.totalVal * 100).toFixed(1);
      });

      this.isProcessing = false;
    })
  }

  pagedItemsMain: any[];
  setPageMain(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.getOneQmsUsersTrainingsRepVwDetails.length, page, this.perPage, targetpage);
    if (this.getOneQmsUsersTrainingsRepVwDetails.length > 0) {
      this.pagedItemsMain = this.getOneQmsUsersTrainingsRepVwDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCallMain(value: number) {
    this.perPage = value;
    this.setPageMain(this.pager.currentPage, 0);
  }

  fileExtn: any;
  todayDate = new Date();
  onConfirmFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.buttonOperationFile = file;
      this.fileExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      this.documentData.documentExtn = this.documentData.documentExtn.toLowerCase();

      // Check if the normalized extension is in the allowed list
      if (!this.allowedFileExtns.includes(this.documentData.documentExtn)) {
        let warningMsgType = "E";
        this.warningMsg = this.documentData.documentExtn + " file type is not allowed, please choose allowed file type.";

        //this.visibleCrInfoPopup = this.dialog.open(this.infoPopup,this.crInfoPopupConfig);
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: this.warningMsg,
            type: warningMsgType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: warningMsgType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      } else {
        let name = file.name.substr(0, file.name.lastIndexOf('.'));
        const formData = new FormData();
        formData.append('file', file ? file : '');
        formData.append("pageName", "DMS");
        formData.append("fileName", name);
        formData.append("extension", this.fileExtn);
        this.isProcessing = true;
        this.appService.fileUploadToServer(formData)
          .subscribe((data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {

            } else {
              this.buttonOperationFile = null;
              this.fileExtn = '';
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }
          }, (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          })
      }

    } else {
      this.buttonOperationFile = '';
      this.fileExtn = '';
    }
  }

  reasonForSignature: any;
  statusChanges(status: any) {
    this.reasonDropdown = [];
    this.selectedReason = null;
    this.selectedReasonValue = "";
    if (status.includes("Signoff")) {
      this.isProcessing = true;
      this.appService.getRoleOfUserForSignoff(this.documentData['documentId'], this.documentData['version'],
        this.buttonLabel).subscribe((data: any) => {
          if (data != null) {
            this.isProcessing = true;
            let obj = {
              stageName: this.buttonLabel,
              status: status,
              module: "DOCS",
              role: data.userRole
            }
            if (this.documentData.belongsToIndividual == "Y") {
              this.appService.getReasonForSignsForBtiByRole(obj).subscribe((data: any) => {
                this.isProcessing = false;
                this.reasonForSignatureList = data;
                for (let i = 0; i < this.reasonForSignatureList.length; i++) {
                  this.reasonDropdown = this.reasonDropdown.concat({
                    valueExp: this.reasonForSignatureList[i].reasonForSignature,
                    displayExp: this.reasonForSignatureList[i].reasonForSignature
                  });
                }
                if (this.reasonForSignatureList.length == 1) {
                  this.reasonForSignature = this.reasonForSignatureList[0].reasonForSignature;
                  this.selectedReasonValue = this.reasonForSignatureList[0].reasonForSignature;
                  for (let i = 0; i < this.reasonDropdown.length; i++) {
                    if (this.reasonDropdown[i].valueExp == this.reasonForSignatureList[0].reasonForSignature) {
                      /*  this.selectedReason = [{
                         valueExp: this.reasonDropdown[i].valueExp,
                         displayExp: this.reasonDropdown[i].displayExp
                       }] */
                      this.selectedReason = this.reasonDropdown[i].valueExp;
                    }
                  }
                }

              })
            } else {
              this.appService.getReasonForSignsByRole(obj).subscribe((data: any) => {
                this.isProcessing = false;
                this.reasonForSignatureList = data;
                for (let i = 0; i < this.reasonForSignatureList.length; i++) {
                  this.reasonDropdown = this.reasonDropdown.concat({
                    valueExp: this.reasonForSignatureList[i].reasonForSignature,
                    displayExp: this.reasonForSignatureList[i].reasonForSignature
                  });
                }
                if (this.reasonForSignatureList.length == 1) {
                  this.reasonForSignature = this.reasonForSignatureList[0].reasonForSignature;

                  this.selectedReasonValue = this.reasonForSignatureList[0].reasonForSignature;
                  for (let i = 0; i < this.reasonDropdown.length; i++) {
                    if (this.reasonDropdown[i].valueExp == this.reasonForSignatureList[0].reasonForSignature) {
                      /*  this.selectedReason = [{
                         valueExp: this.reasonDropdown[i].valueExp,
                         displayExp: this.reasonDropdown[i].displayExp
                       }] */
                      this.selectedReason = this.reasonDropdown[i].valueExp;
                    }
                  }
                }

              })
            }

          }
        })
    } else {
      this.isProcessing = true;
      let data = {
        stageName: this.buttonLabel,
        status: status,
        module: "DOCS",
      }
      if (this.documentData.belongsToIndividual == "Y") {
        this.reasonDropdown = [];
        this.appService.getReasonForSignsForBti(data).subscribe((data: any) => {
          this.isProcessing = false;
          this.reasonForSignatureList = data;
          for (let i = 0; i < this.reasonForSignatureList.length; i++) {
            this.reasonDropdown = this.reasonDropdown.concat({
              valueExp: this.reasonForSignatureList[i].reasonForSignature,
              displayExp: this.reasonForSignatureList[i].reasonForSignature
            });
          }
          if (this.reasonForSignatureList.length == 1) {
            this.reasonForSignature = this.reasonForSignatureList[0].reasonForSignature;

            this.selectedReasonValue = this.reasonForSignatureList[0].reasonForSignature;
            for (let i = 0; i < this.reasonDropdown.length; i++) {
              if (this.reasonDropdown[i].valueExp == this.reasonForSignatureList[0].reasonForSignature) {
                /*  this.selectedReason = [{
                   valueExp: this.reasonDropdown[i].valueExp,
                   displayExp: this.reasonDropdown[i].displayExp
                 }] */
                this.selectedReason = this.reasonDropdown[i].valueExp
              }
            }
          }

        })
      } else {
        this.reasonDropdown = [];
        this.appService.getReasonForSigns(data).subscribe((data: any) => {
          this.isProcessing = false;
          this.reasonForSignatureList = data;
          for (let i = 0; i < this.reasonForSignatureList.length; i++) {
            this.reasonDropdown = this.reasonDropdown.concat({
              valueExp: this.reasonForSignatureList[i].reasonForSignature,
              displayExp: this.reasonForSignatureList[i].reasonForSignature
            });
          }
          if (this.reasonForSignatureList.length == 1) {
            this.reasonForSignature = this.reasonForSignatureList[0].reasonForSignature;

            this.selectedReasonValue = this.reasonForSignatureList[0].reasonForSignature;
            for (let i = 0; i < this.reasonDropdown.length; i++) {
              if (this.reasonDropdown[i].valueExp == this.reasonForSignatureList[0].reasonForSignature) {
                /*  this.selectedReason = [{
                   valueExp: this.reasonDropdown[i].valueExp,
                   displayExp: this.reasonDropdown[i].displayExp
                 }] */
                this.selectedReason = this.reasonDropdown[i].valueExp
              }
            }
          }

        })
      }

    }

  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  checkoutDocList: any = [];
  onChange(i: any, event: any) {
    if (event.checked) {
      if (this.checkoutDocList.indexOf(event.source.value) == -1) {
        this.checkoutDocList.push(event.source.value);
      }
    } else {
      this.checkoutDocList.splice(this.checkoutDocList.indexOf(event.source.value), 1);
    }


  }

  callAssociatedDocCheckout() {
    for (let j = 0; j < this.checkoutDocList.length; j++) {
      for (let i = 0; i < this.associatedDocumentListForCheckout.length; i++) {
        if (this.checkoutDocList[j] == this.associatedDocumentListForCheckout[i].documentId) {
          let data = {

            documentId: this.associatedDocumentListForCheckout[i]['documentId'],
            version: this.associatedDocumentListForCheckout[i]['version'],
            currentStatus: this.associatedDocumentListForCheckout[i]['status'],
            stageName: null,
            buttonValue: this.buttonLabel,
            actionStatus: null,
            crNo: this.checkoutcrNo,
            comments: this.reason,
            rejectReason: null,
            reasonForSignature: null,
            fileExtn: null,
            effectiveDate: null,
            expirationDate: null
          }
          const formData = new FormData();
          const emptyfile: File | any = null;
          formData.append('file', emptyfile);
          const json = JSON.stringify(data);
          const blob = new Blob([json], {
            type: 'application/json'
          });
          formData.append('object', blob);
          this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
            this.isProcessing = false;
            if (Response.resultType == "S") {

            } else {
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }

            this.isProcessing = false;
          })
        }
      }
    }

  }
  collabractiveReview() {


    const formData = new FormData();
    let data = {
      documentId: this.documentData['documentId'],
      version: this.documentData['version'],
      accessToken: this.accessToken,
      hostname: this.message.hostName,  //"clinevo.sharepoint.com"
      sitePath: this.message.sitePath,//"
      corevivwerList: this.selectedUser.toString(),
      comments: this.comments,
      rejectReason: this.selectedRejectReasonValue,
      reasonForSignature: this.selectedReasonValue,
      documentExtn: this.documentData.documentExtn
    }


    //  formData.append('file', this.document.body);
    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    formData.append('dmsDocumentsOnlineDto', blob);



    this.appService.performonlieneditAssignUserre(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      this.visibleConfirmWithReason.close();
      if (Response.resultType == "S") {

        this.isProcessing = true;
        this.appService.getDocumentByDocumentId(
          this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
            this.documentData = data[0];
            this.documentData['saveButtonForDocument'] = false;
            this.isProcessing = false;
            this.getInitialCall()
          })


      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })

  }

  confirmWithReasonFunc() {

    this.isProcessing = true;
    if (this.buttonLabel == "Collaborative Review" || this.buttonLabel == "Change Collaborative Reviewers") {

      this.isProcessing = true;


      //"96f90c99-090c-457a-a431-f1031e963ea1", "fb4ef167-3345-4fa6-b20c-ce1651ecddeb"
      this.handleButtonClick(this.message.tenantId, this.message.clientId, "Collaborative Review");


    } else if (((this.reason == "" || this.reason == null) && this.buttonLabel != 'Publish') || (this.checkoutcrNo == null && this.buttonLabel == "CheckOut" && this.isCrFeildIsMandatory) ||
      ((this.documentData.effectiveDate == null || (this.isShowExpDate && this.documentData.expirationDate == null)) && this.buttonLabel == 'Publish')) {
      this.deleteReasonValidation();
      this.isProcessing = false;
    } else {

      if (this.buttonLabel == "CheckIn" && this.saveButtonForDocument) {
        this.saveDocument('CheckIn');
      } else {
        this.performCommonOperation();
      }


    }

  }

  performCommonOperation() {
    let data = {

      documentId: this.documentData['documentId'],
      version: this.documentData['version'],
      currentStatus: this.documentData['status'],
      stageName: null,
      buttonValue: this.buttonLabel,
      actionStatus: null,
      crNo: this.checkoutcrNo,
      comments: this.reason,
      rejectReason: null,
      reasonForSignature: null,
      fileExtn: null,
      effectiveDate: this.documentData.effectiveDate,
      expirationDate: this.documentData.expirationDate
    }
    if (this.documentData.effectiveDate != null) {
      const effectiveDateValue = new Date(this.documentData.effectiveDate);
      data.effectiveDate = this.appService.dateZoneConvertion(effectiveDateValue);
    }
    if (this.documentData.expirationDate != null) {
      const expirationDateValue = new Date(this.documentData.expirationDate);
      data.expirationDate = this.appService.dateZoneConvertion(expirationDateValue);
    }
    if (this.buttonLabel == "Submit for Review" || this.buttonLabel == "Submit for Approval" || this.buttonLabel == "Submit for Signoff") {
      data.stageName = this.stageName;
    }
    const formData = new FormData();
    const emptyfile: File | any = null;
    formData.append('file', emptyfile);
    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    formData.append('object', blob);
    this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        if (this.buttonLabel == "CheckOut") {
          this.callAssociatedDocCheckout();
        }
        if (this.visibleConfirmWithReason != undefined) {
          this.visibleConfirmWithReason.close();
        }
        if (this.visiblPublishConfirmPopup != undefined) {
          this.visiblPublishConfirmPopup.close();
        }
        if (this.visiblPublishPopup != undefined) {
          this.visiblPublishPopup.close();
        }

        this.appService.getDocumentByDocIdFirstTime(
          this.documentData.documentId).subscribe((data: any) => {
            if (data.length > 0) {
              this.patchDocumentData(data[0]);
              this.documentData['saveButtonForDocument'] = false;
              this.isProcessing = false;
              this.getInitialCall();
            } else {
              history.back();
            }
          })
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }


  deleteReasonValidation() {
    const reason = document.getElementById('reason') as HTMLInputElement;
    const effectiveDate = document.getElementById('effectiveDate') as HTMLInputElement;
    const reasonRequiredMsg = document.getElementById('reason-required-msg') as HTMLInputElement;
    const effectiveDateRequiredMsg = document.getElementById('effectiveDate-required-msg') as HTMLInputElement;

    // Only get expiration elements if the field is visible in DOM
    const expirationDate = this.isShowExpDate
      ? document.getElementById('expirationDate') as HTMLInputElement
      : null;
    const expirationDateRequiredMsg = this.isShowExpDate
      ? document.getElementById('expirationDate-required-msg') as HTMLInputElement
      : null;

    const checkoutCr = document.getElementById('crForCheckout') as HTMLInputElement;
    const checkoutCrRequiredMsg = document.getElementById('crForCheckout-required-msg') as HTMLInputElement;

    if (this.buttonLabel != 'Publish') {
      if (this.reason == "" || this.reason == null || this.reason == undefined) {
        if (reason) reason.style.border = '1px solid red';
        if (reasonRequiredMsg) reasonRequiredMsg.style.display = 'block';
      } else {
        if (reason) reason.style.border = 'none';
        if (reasonRequiredMsg) reasonRequiredMsg.style.display = 'none';
      }
    }

    if (this.buttonLabel == 'CheckOut') {
      if (this.isCrFeildIsMandatory) {
        if (this.checkoutcrNo == null) {
          if (checkoutCr) checkoutCr.style.border = '1px solid red';
          if (checkoutCrRequiredMsg) checkoutCrRequiredMsg.style.display = 'block';
        } else {
          if (checkoutCr) checkoutCr.style.border = 'none';
          if (checkoutCrRequiredMsg) checkoutCrRequiredMsg.style.display = 'none';
        }
      }
    }

    if (this.buttonLabel == 'Publish') {
      // Effective date validation
      if (effectiveDate) {  // null check
        if (this.documentData.effectiveDate == null) {
          effectiveDate.style.border = '1px solid red';
          if (effectiveDateRequiredMsg) effectiveDateRequiredMsg.style.display = 'block';
        } else {
          effectiveDate.style.border = 'none';
          if (effectiveDateRequiredMsg) effectiveDateRequiredMsg.style.display = 'none';
        }
      }

      if (this.isShowExpDate && expirationDate) {
        if (this.documentData.expirationDate == null) {
          expirationDate.style.border = '1px solid red';
          if (expirationDateRequiredMsg) expirationDateRequiredMsg.style.display = 'block';
        } else {
          expirationDate.style.border = 'none';
          if (expirationDateRequiredMsg) expirationDateRequiredMsg.style.display = 'none';
        }
      }
    }
  }
  selectedRejectReasonValue: any = "";
  selectedStatusValue: any = "";
  selectedReasonValue: any = "";

  onStatusSelect(item: any) {
    this.selectedStatusValue = item;
    this.changetypeAddAndEditPassword = true;
    this.password = "";
    if (this.selectedStatusValue.includes("Requested More Info.")) {
      this.isReasonSignReqd = false;
    } else {
      if (this.moduleStage.reasonForSignatureReqd == "Y") {
        this.isReasonSignReqd = true;
      }
      this.statusChanges(this.selectedStatusValue);
    }

    if (this.rejectReasonList.length > 0 && (this.selectedStatusValue == 'Review Rejected'
      || this.selectedStatusValue == 'Approval Rejected' || this.selectedStatusValue == 'Signoff Rejected')) {
      this.isShowRejectReason = true;
    } else {
      this.isShowRejectReason = false;
    }
  }
  onStatusRemoved(item: any) {
    this.selectedStatusValue = "";
    this.isShowRejectReason = false;
  }

  onReasonSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedReasonValue = item?.valueExp ?? null;
    }
  }

  onReasonSelectOld(item: any) {
    this.selectedReasonValue = item.valueExp;
  }
  onReasonRemoved(item: any) {
    this.selectedReasonValue = "";
  }

  onRejectReasonSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedRejectReasonValue = item?.valueExp ?? null;
    }
  }

  onRejectReasonSelectOld(item: any) {
    this.selectedRejectReasonValue = item.valueExp;
  }
  onRejectReasonRemoved(item: any) {
    this.selectedRejectReasonValue = "";
  }

  cancelConfirmFunc() {
    this.visibleConfirm.close();
  }

  configureMsalInstance(clientId: string, tenantId: string): void {
    // Reinitialize the MSAL instance with updated configuration
    this.authService.instance = new PublicClientApplication({
      auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: location.origin + '/profile',
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
      },
    }), {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: ['user.read']
      }
    }, {
      interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
      protectedResourceMap: new Map([
        ['https://graph.microsoft.com/v1.0/me', ['user.read']]
      ])
    };
  }

  buttonOperationFile: any | File;

  handleButtonClick(tenantId: string, clientId: string, callingPlace: string) {
    console.log('Telnet ID:', tenantId);
    console.log('Client ID:', clientId);

    // Trigger login popup for user validation
    this.authService1.loginPopup().then(
      (response) => {
        console.log('Login successful:', response);
        this.accessToken = response.accessToken;
        // Set the active account
        this.authService1.setActiveAccount(response.account);

        if (callingPlace == 'Edit Online') {
          this.editOnlie();
        } else if (callingPlace == 'confirmOkCoauthor') {
          this.confirmOkfunction();
          this.isProcessing = false;
        } else if (callingPlace == 'pullTheDocumentInserver') {
          this.pullTheDocumentInserver();
        } else if (callingPlace == 'Verify the Changes') {
          this.varifyThefile();
        } else if (callingPlace == 'Collaborative Review') {
          this.collabractiveReview();
        }
      },
      (error) => {
        console.error('Login failed:', error);
      }
    );
  }

  confirmOkCoauthor() {
    this.handleButtonClick(this.message.tenantId, this.message.clientId, "confirmOkCoauthor");
  }
  confirmOkfunction() {

    this.isProcessing = true;
    const formData = new FormData();
    //   formData.append('file', this.document.body);
    formData.append('documentId', this.documentData.documentId);
    formData.append('accessToken', this.documentData.version);
    formData.append('docVersion', this.documentData.version);

    let data = {
      documentId: this.documentData['documentId'],
      version: this.documentData['version'],
      accessToken: this.accessToken,
      stageName: this.stageName,
      buttonValue: this.buttonLabel,
      hostname: this.message.hostName,  //"clinevo.sharepoint.com"
      sitePath: this.message.sitePath,//"
      actionStatus: this.selectedStatusValue,
      comments: this.comments,
      rejectReason: this.selectedRejectReasonValue,
      reasonForSignature: this.selectedReasonValue,
      documentExtn: this.documentData.documentExtn,
      coAuthorList: this.selectedUser.toString(),
    }

    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    formData.append('dmsDocumentsOnlineDto', blob);



    this.appService.performonlieneditcoauthor(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      this.visibleConfirmCoauthor.close();
      if (Response.resultType == "S") {

        this.isProcessing = true;
        this.appService.getDocumentByDocumentId(
          this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
            this.patchDocumentData(data[0]);
            this.documentData['saveButtonForDocument'] = false;
            this.isProcessing = false;
            this.getInitialCall()
          })


      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })


  }

  editOnlie() {

    this.isProcessing = true;
    const formData = new FormData();
    //   formData.append('file', this.document.body);
    formData.append('documentId', this.documentData.documentId);
    formData.append('accessToken', this.documentData.version);
    formData.append('docVersion', this.documentData.version);

    let data = {

      documentId: this.documentData['documentId'],
      version: this.documentData['version'],
      accessToken: this.accessToken,
      stageName: this.stageName,
      buttonValue: this.buttonLabel,
      hostname: this.message.hostName,  //"clinevo.sharepoint.com"
      sitePath: this.message.sitePath,//"ProjectSite",
      actionStatus: this.selectedStatusValue,
      comments: this.comments,
      rejectReason: this.selectedRejectReasonValue,
      reasonForSignature: this.selectedReasonValue,
      documentExtn: this.documentData.documentExtn,
      coAuthorList: this.message.getUserId()
    }

    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    formData.append('dmsDocumentsOnlineDto', blob);
    const blob1 = new Blob([this.document.body]);

    const emptyfile: File | any = null;
    formData.append("file", blob1);




    this.appService.performEditOnlineForDocument(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      this.visibleConfirm.close();
      if (Response.resultType == "S") {

        this.isProcessing = true;
        this.appService.getDocumentByDocumentId(
          this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
            this.documentData = data[0];
            this.documentData['saveButtonForDocument'] = false;
            this.isProcessing = false;
            this.getInitialCall()
          })


      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })

  }

  confirmOkFunc() {
    if (this.buttonLabel == "Cancel Edit Online") {

      this.isProcessing = true;
      const formData = new FormData();


      let data = {

        documentId: this.documentData['documentId'],
        version: this.documentData['version'],
        accessToken: this.accessToken,
        stageName: this.stageName,
        buttonValue: this.buttonLabel,
        hostname: this.message.hostName,  //"clinevo.sharepoint.com"
        sitePath: this.message.sitePath,//"
        actionStatus: this.selectedStatusValue,
        comments: this.comments,
        rejectReason: this.selectedRejectReasonValue,
        reasonForSignature: this.selectedReasonValue,
        documentExtn: this.documentData.documentExtn
      }

      const json = JSON.stringify(data);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('dmsDocumentsOnlineDto', blob);



      this.appService.cancelonlineedit(formData).subscribe((Response: any) => {
        this.isProcessing = false;
        this.visibleConfirm.close();
        if (Response.resultType == "S") {

          this.isProcessing = true;
          this.appService.getDocumentByDocumentId(
            this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
              if (data.length > 0) {
                const previousDestructionCount = this.documentData.destructionCount;
                const previousTagsCount = this.documentData.tagsCount;
                const previousExtensionCount = this.documentData.extensionCount;
                const previousWithdrawCount = this.documentData.withdrawCount;

                this.documentData = data[0];

                if (this.documentData.destructionCount === undefined) {
                  this.documentData.destructionCount = previousDestructionCount;
                }
                if (this.documentData.tagsCount === undefined) {
                  this.documentData.tagsCount = previousTagsCount;
                }
                if (this.documentData.extensionCount === undefined) {
                  this.documentData.extensionCount = previousExtensionCount;
                }
                if (this.documentData.withdrawCount === undefined) {
                  this.documentData.withdrawCount = previousWithdrawCount;
                }

                this.documentData['saveButtonForDocument'] = false;
                this.isProcessing = false;
                this.getInitialCall();
              }
            })


        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      })

    } else if (this.buttonLabel == "Cancel Collaborative Review") {

      this.isProcessing = true;
      const formData = new FormData();


      let data = {

        documentId: this.documentData['documentId'],
        version: this.documentData['version'],
        accessToken: this.accessToken,
        stageName: this.stageName,
        buttonValue: this.buttonLabel,
        hostname: this.message.hostName,  //"clinevo.sharepoint.com"
        sitePath: this.message.sitePath,//"
        actionStatus: this.selectedStatusValue,
        comments: this.comments,
        rejectReason: this.selectedRejectReasonValue,
        reasonForSignature: this.selectedReasonValue,
        documentExtn: this.documentData.documentExtn
      }

      const json = JSON.stringify(data);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('dmsDocumentsOnlineDto', blob);

      this.appService.collabrativeReviwCancel(formData).subscribe((Response: any) => {
        this.isProcessing = false;
        this.visibleConfirm.close();
        if (Response.resultType == "S") {

          this.isProcessing = true;
          this.appService.getDocumentByDocumentId(
            this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
              this.documentData = data[0];
              this.documentData['saveButtonForDocument'] = false;
              this.isProcessing = false;
              this.getInitialCall()
            })


        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      })

    } else if (this.buttonLabel == "Verify the Changes") {
      this.visibleConfirm.close();
      this.handleButtonClick(this.message.tenantId, this.message.clientId, "Verify the Changes");

    } else if (this.buttonLabel == "Edit Online") {


      this.handleButtonClick(this.message.tenantId, this.message.clientId, "Edit Online");

    } else {
      this.isProcessing = true;
      let data = {
        documentId: this.documentData['documentId'],
        version: this.documentData['version'],
        currentStatus: this.documentData['status'],
        stageName: null,
        buttonValue: this.buttonLabel,
        actionStatus: null,
        comments: null,
        crNo: null,
        rejectReason: null,
        reasonForSignature: null,
        childCancelCheckoutFlag: this.isChildCancelCheckoutFlag ? "Y" : "N"
      }
      const formData = new FormData();
      formData.append('file', this.buttonOperationFile);
      const json = JSON.stringify(data);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('object', blob);
      this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
        this.isProcessing = false;
        this.visibleConfirm.close();
        if (Response.resultType == "S") {
          if (this.buttonLabel == "Undo" || this.buttonLabel == "Cancel Checkout") {
            this.isProcessing = true;
            this.appService.getDocumentByDocIdFirstTime(
              this.documentData.documentId).subscribe((data: any) => {
                if (data.length > 0) {
                  this.documentData = data[0];
                  this.documentData['saveButtonForDocument'] = false;
                  this.isProcessing = false;
                  this.getInitialCall()
                } else {
                  history.back();
                }

              })
          } else {
            this.isProcessing = true;
            this.appService.getDocumentByDocumentId(
              this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
                this.documentData = data[0];
                this.documentData['saveButtonForDocument'] = false;
                this.isProcessing = false;
                this.getInitialCall()
              })
          }

        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      })
    }

  }

  cancelConfirmWithDataFunc() {
    this.visibleConfirmWithData.close();
  }

  performButtonOperationForDocument(formData: FormData) {
    this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        this.visibleConfirmWithData.close();
        if (Response.result.includes("published")) {
          this.isProcessing = true;
          this.appService.getDocumentByDocIdFirstTime(
            this.documentData.documentId).subscribe((data: any) => {
              this.documentData = data[0];
              this.documentData['saveButtonForDocument'] = false;
              this.isProcessing = false;
              this.getInitialCall()
            })
        } else {
          this.isProcessing = true;
          this.appService.getDocumentByDocumentId(
            this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
              if (data.length > 0) {
                const previousDestructionCount = this.documentData.destructionCount;
                const previousTagsCount = this.documentData.tagsCount;
                const previousExtensionCount = this.documentData.extensionCount;
                const previousWithdrawCount = this.documentData.withdrawCount;
                this.patchDocumentData(data[0]);
                this.documentData['saveButtonForDocument'] = false;
                this.isProcessing = false;
                this.getInitialCall();
              }
            })
        }

      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }
  authEnable(flag: string) {

    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            if (flag == "reviewAuthenable") {
              let data = {
                documentId: this.documentData['documentId'],
                version: this.documentData['version'],
                currentStatus: this.documentData['status'],
                stageName: this.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatusValue,
                comments: this.comments,
                rejectReason: this.selectedRejectReasonValue,
                reasonForSignature: this.selectedReasonValue,
                fileExtn: this.fileExtn,
              }
              const formData = new FormData();
              const emptyfile: File | any = null;
              formData.append('file', this.buttonOperationFile);
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('object', blob);
              this.performButtonOperationForDocument(formData)
            }
            this.isProcessing = false;
          } else {
            this.isProcessing = false;
          }
        },
        error: (error) => {
          this.isProcessing = false;
        }
      });
  }

  patchDocumentData(newData: any) {
    // 1. Capture the existing counts before they get overwritten
    const countsToPreserve = {
      destructionCount: this.documentData?.destructionCount,
      tagsCount: this.documentData?.tagsCount,
      extensionCount: this.documentData?.extensionCount,
      withdrawCount: this.documentData?.withdrawCount
    };

    // 2. Overwrite with the fresh data from the API
    this.documentData = newData;

    // 3. Restore the counts if the API sent them back as null or undefined
    if (this.documentData.destructionCount == null) {
      this.documentData.destructionCount = countsToPreserve.destructionCount;
    }
    if (this.documentData.tagsCount == null) {
      this.documentData.tagsCount = countsToPreserve.tagsCount;
    }
    if (this.documentData.extensionCount == null) {
      this.documentData.extensionCount = countsToPreserve.extensionCount;
    }
    if (this.documentData.withdrawCount == null) {
      this.documentData.withdrawCount = countsToPreserve.withdrawCount;
    }
  }

  confirmWithDataFunc() {
    this.isProcessing = true;

    // Centralized validation condition
    const isStatusEmpty = this.selectedStatusValue == "";
    const isRejectReasonMissing = this.isShowRejectReason && (this.selectedRejectReasonValue == "" || this.selectedRejectReasonValue == null);
    const isReasonForSignatureMissing = this.isReasonSignReqd && (this.selectedReasonValue == "" || this.selectedReasonValue == null);

    if (isStatusEmpty || isRejectReasonMissing || isReasonForSignatureMissing) {
      this.buttonOperationFieldValidation();
      this.isProcessing = false;
      return;
    }

    if (this.isEsignRequired && localStorage.getItem("adEnabled") == 'Y') {
      this.authEnable("reviewAuthenable");
    } else if (!this.isEsignRequired && localStorage.getItem("adEnabled") == 'Y') {
      let data = {

        documentId: this.documentData['documentId'],
        version: this.documentData['version'],
        currentStatus: this.documentData['status'],
        stageName: this.stageName,
        buttonValue: this.buttonLabel,
        actionStatus: this.selectedStatusValue,
        comments: this.comments,
        rejectReason: this.selectedRejectReasonValue,
        reasonForSignature: this.selectedReasonValue,
        fileExtn: this.fileExtn,
      };
      const formData = new FormData();
      formData.append('file', this.buttonOperationFile ?? '');
      const json = JSON.stringify(data);
      const blob = new Blob([json], { type: 'application/json' });
      formData.append('object', blob);
      this.performButtonOperationForDocument(formData);
    } else if (this.isEsignRequired) {
      if (this.password == "") {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
        return;
      }
      let authData = {
        userName: this.userName,
        password: this.password,
      };
      this.appService.validateUser(authData).subscribe((response: any) => {
        if (response.resultType == "S") {
          // Re-check validation after auth (optional but safe)
          if (isStatusEmpty || isRejectReasonMissing || isReasonForSignatureMissing) {
            this.buttonOperationFieldValidation();
            this.isProcessing = false;
            return;
          }
          let data = {

            documentId: this.documentData['documentId'],
            version: this.documentData['version'],
            currentStatus: this.documentData['status'],
            stageName: this.stageName,
            buttonValue: this.buttonLabel,
            actionStatus: this.selectedStatusValue,
            comments: this.comments,
            rejectReason: this.selectedRejectReasonValue,
            reasonForSignature: this.selectedReasonValue,
            fileExtn: this.fileExtn,
          };
          const formData = new FormData();
          formData.append('file', this.buttonOperationFile ?? '');
          const json = JSON.stringify(data);
          const blob = new Blob([json], { type: 'application/json' });
          formData.append('object', blob);
          this.performButtonOperationForDocument(formData);
        } else {
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: response.result,
              type: response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => sb.dismiss());
          this.isProcessing = false;
        }
      });
    } else {
      let data = {

        documentId: this.documentData['documentId'],
        version: this.documentData['version'],
        currentStatus: this.documentData['status'],
        stageName: this.stageName,
        buttonValue: this.buttonLabel,
        actionStatus: this.selectedStatusValue,
        comments: this.comments,
        rejectReason: this.selectedRejectReasonValue,
        reasonForSignature: this.selectedReasonValue,
        fileExtn: this.fileExtn,
      };
      const formData = new FormData();
      formData.append('file', this.buttonOperationFile ?? '');
      const json = JSON.stringify(data);
      const blob = new Blob([json], { type: 'application/json' });
      formData.append('object', blob);
      this.performButtonOperationForDocument(formData);
    }

    this.isProcessing = false;
  }
  isShowRejectReason = false;

  status: any;
  pass: any;
  rejectReason1: any;
  reasonForSignature1: any;

  statusRequiredMsg: any;
  passRequiredMsg: any;
  rejectReasonRequiredMsg: any;
  reasonForSignatureRequiredMsg: any;
  buttonOperationFieldValidation() {
    //this.isProcessing = true;
    this.status = document.getElementById('status') as HTMLInputElement;
    this.pass = document.getElementById('pass') as HTMLInputElement;
    this.rejectReason1 = document.getElementById('rejectReason') as HTMLInputElement;
    this.reasonForSignature1 = document.getElementById('reasonForSignature') as HTMLInputElement;

    this.statusRequiredMsg = document.getElementById('status-required-msg') as HTMLInputElement;
    this.passRequiredMsg = document.getElementById('pass-required-msg') as HTMLInputElement;
    this.rejectReasonRequiredMsg = document.getElementById('rejectReason-required-msg') as HTMLInputElement;
    this.reasonForSignatureRequiredMsg = document.getElementById('reasonForSignature-required-msg') as HTMLInputElement;


    if (this.selectedStatusValue == "") {
      this.status.style.border = '1px solid red';
      this.statusRequiredMsg.style.display = 'block';
    } else {
      this.status.style.border = 'none';
      this.statusRequiredMsg.style.display = 'none';
    }
    if (localStorage.getItem("adEnabled") != 'Y') {
      if (this.password == "") {
        this.pass.style.border = '1px solid red';
        this.passRequiredMsg.style.display = 'block';
      } else {
        this.pass.style.border = 'none';
        this.passRequiredMsg.style.display = 'none';
      }
    }
    if (this.isShowRejectReason && this.selectedRejectReasonValue == "") {
      if (this.selectedRejectReasonValue == "") {
        this.rejectReason1.style.border = '1px solid red';
        this.rejectReasonRequiredMsg.style.display = 'block';
      } else {
        this.rejectReason1.style.border = 'none';
        this.rejectReasonRequiredMsg.style.display = 'none';
      }
    }

    if (this.isReasonSignReqd) {
      if (this.selectedReasonValue == "" || this.selectedReasonValue == null) {
        this.reasonForSignature1.style.border = '1px solid red';
        this.reasonForSignatureRequiredMsg.style.display = 'block';
      } else {
        this.reasonForSignature1.style.border = 'none';
        this.reasonForSignatureRequiredMsg.style.display = 'none';
      }
    }


  }

  isGridCollapsed = false;
  isAdditionalDetailsCollapsed = true;
  revisionHistoryCollapsed = true;
  isAssociatedDocCollapsed = true;
  gridExpandCollapseFunc() {
    if (this.isGridCollapsed) {
      this.isGridCollapsed = false;
    } else {
      this.isGridCollapsed = true;
    }
  }

  additionalDetailExpandCollapseFunc() {
    if (this.isAdditionalDetailsCollapsed) {
      this.isAdditionalDetailsCollapsed = false;
    } else {
      this.isAdditionalDetailsCollapsed = true;
    }
  }

  revisionHistoryCollapseFunc() {
    if (this.revisionHistoryCollapsed) {
      this.revisionHistoryCollapsed = false;
    } else {
      this.revisionHistoryCollapsed = true;
    }
  }

  associatedDocExpandCollapseFunc() {
    if (this.isAssociatedDocCollapsed) {
      this.isAssociatedDocCollapsed = false;
    } else {
      this.isAssociatedDocCollapsed = true;
    }
  }

  selectExpValue(date: Date) {
    console.log("expirationDate1");
    if (this.documentData['expirationDate'] == null) {
      console.log("this.documentData=", this.documentData);
      console.log("this.documentData.associatedDocumentId=", this.documentData.associatedDocumentId);
      console.log("this.isShowExpDate=", this.isShowExpDate);
      console.log("this.followSameExpDate=", this.followSameExpDate);
      console.log("this.selectedAssociatedDoc.expirationDate=", this.selectedAssociatedDoc.expirationDate);

      if (this.documentData.associatedDocumentId != undefined && this.documentData.associatedDocumentId != null && this.isShowExpDate) {
        this.appService.getDocumentByDocIdFirstTime(
          this.documentData.associatedDocumentId).subscribe((data: any) => {
            this.selectedAssociatedDoc = data[0];
            let followSameExpDate1;
            for (const element1 of this.dropDownFordocumentTypeList) {
              if (element1.documentTypeCode == this.selectedAssociatedDoc.documentTypeCode) {
                if (element1.associatedDocToFollowSameExpiry == "Y") {
                  followSameExpDate1 = true;
                }
              }
            }
            if (followSameExpDate1) {
              console.log("this.selectedAssociatedDoc=", this.selectedAssociatedDoc);
              if (this.selectedAssociatedDoc.expirationDate != null) {
                console.log("expirationDate3");
                this.tempDateExpiration = new Date(this.selectedAssociatedDoc.expirationDate);
                this.documentData.expirationDate = new Date(this.selectedAssociatedDoc.expirationDate);
              }
            } else if (this.documentTypeData.expiryInUnit != null) {
              console.log("expirationDate4");
              this.documentData['expirationDate'] = new Date();
              this.documentData['expirationDate'].setDate(date.getDate());
              this.documentData['expirationDate'].setMonth(date.getMonth());
              this.documentData['expirationDate'].setFullYear(date.getFullYear());
              if (this.documentTypeData.expiryInUnit == "Days") {
                this.documentData['expirationDate'].setDate(date.getDate() + this.documentTypeData.expiryIn);
              } else if (this.documentTypeData.expiryInUnit == "Month") {
                this.documentData['expirationDate'].setMonth(date.getMonth() + this.documentTypeData.expiryIn);
              } else {
                this.documentData['expirationDate'].setFullYear(date.getFullYear() + this.documentTypeData.expiryIn);
              }
            }
          });
      } else if (this.documentTypeData.expiryInUnit != null) {
        console.log("expirationDate4");
        this.documentData['expirationDate'] = new Date();
        this.documentData['expirationDate'].setDate(date.getDate());
        this.documentData['expirationDate'].setMonth(date.getMonth());
        this.documentData['expirationDate'].setFullYear(date.getFullYear());
        if (this.documentTypeData.expiryInUnit == "Days") {
          this.documentData['expirationDate'].setDate(date.getDate() + this.documentTypeData.expiryIn);
        } else if (this.documentTypeData.expiryInUnit == "Month") {
          this.documentData['expirationDate'].setMonth(date.getMonth() + this.documentTypeData.expiryIn);
        } else {
          this.documentData['expirationDate'].setFullYear(date.getFullYear() + this.documentTypeData.expiryIn);
        }
      }
    } else {
      if (this.documentData.associatedDocumentId != undefined && this.documentData.associatedDocumentId != null && this.isShowExpDate) {
        this.appService.getDocumentByDocIdFirstTime(
          this.documentData.associatedDocumentId).subscribe((data: any) => {
            this.selectedAssociatedDoc = data[0];
            let followSameExpDate1;
            for (const element1 of this.dropDownFordocumentTypeList) {
              if (element1.documentTypeCode == this.selectedAssociatedDoc.documentTypeCode) {
                if (element1.associatedDocToFollowSameExpiry == "Y") {
                  followSameExpDate1 = true;
                }
              }
            }
            if (followSameExpDate1) {
              console.log("this.selectedAssociatedDoc=", this.selectedAssociatedDoc);
              if (this.selectedAssociatedDoc.expirationDate != null) {
                console.log("expirationDate3");
                this.tempDateExpiration = new Date(this.selectedAssociatedDoc.expirationDate);
                this.documentData.expirationDate = new Date(this.selectedAssociatedDoc.expirationDate);
              }
            } else if (this.documentTypeData.expiryInUnit != null) {
              console.log("expirationDate4");
              this.documentData['expirationDate'] = new Date();
              this.documentData['expirationDate'].setDate(date.getDate());
              this.documentData['expirationDate'].setMonth(date.getMonth());
              this.documentData['expirationDate'].setFullYear(date.getFullYear());
              if (this.documentTypeData.expiryInUnit == "Days") {
                this.documentData['expirationDate'].setDate(date.getDate() + this.documentTypeData.expiryIn);
              } else if (this.documentTypeData.expiryInUnit == "Month") {
                this.documentData['expirationDate'].setMonth(date.getMonth() + this.documentTypeData.expiryIn);
              } else {
                this.documentData['expirationDate'].setFullYear(date.getFullYear() + this.documentTypeData.expiryIn);
              }
            }
          });
      }
      else if (this.documentTypeData.expiryInUnit != null) {
        console.log("expirationDate4");
        this.documentData['expirationDate'] = new Date();
        this.documentData['expirationDate'].setDate(date.getDate());
        this.documentData['expirationDate'].setMonth(date.getMonth());
        this.documentData['expirationDate'].setFullYear(date.getFullYear());
        if (this.documentTypeData.expiryInUnit == "Days") {
          this.documentData['expirationDate'].setDate(date.getDate() + this.documentTypeData.expiryIn);
        } else if (this.documentTypeData.expiryInUnit == "Month") {
          this.documentData['expirationDate'].setMonth(date.getMonth() + this.documentTypeData.expiryIn);
        } else {
          this.documentData['expirationDate'].setFullYear(date.getFullYear() + this.documentTypeData.expiryIn);
        }
      }
    }
  }

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;
  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  openTopicPopup() {
    this.message.communicatingFrom = 'DOCS';
    let documentDataForCommunication = {
      documentId: this.documentData.documentId,
      documentVersion: this.documentData.version,
    }
    this.message.serviceFromDocumentsForCommunication = documentDataForCommunication;
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }

  canceltopicPopup() {
    this.visibleTopicPopup.close();
  }

  getDocs(type: any) {
    return this.documentsByDocTypeList[type];
  }

  isSideBarCollapsed: boolean = false;
  sideBarExpandCollpaseFunc() {
    if (this.isSideBarCollapsed) {
      this.isSideBarCollapsed = false;
    } else {
      this.isSideBarCollapsed = true;
    }
  }

  clickedDoc: any = {};
  viewAssociatedDoc: boolean = false;
  openAssDocInViewer(doc: any) {
    this.clickedDoc = doc;
    this.viewAssociatedDoc = true;
    if (doc.documentExtn != null) {
      if (this.viewableExtensionsList.length > 0) {
        for (let q = 0; q < this.viewableExtensionsList.length; q++) {
          if (this.viewableExtensionsList[q].toUpperCase() == doc.documentExtn.toUpperCase()) {
            this.isViewableFile = false;
            this.appService.getDocumentsToViewForDms(
              doc['documentId'], doc['version']).subscribe((data: any) => {

                this.loadDataInViewer(data, doc.documentExtn, this.viewer);

              })

            break;
          } else {
            this.isViewableFile = true;
            this.isShowToUploadDiffFile = true;
            this.NotviewableValue.style.display = 'none';
          }

        }
      } else {
        this.isViewableFile = true;
        this.isShowToUploadDiffFile = true;
        this.NotviewableValue.style.display = 'none';
      }

    }
  }

  backToViewMainDoc() {
    this.viewAssociatedDoc = false;
    if (this.documentData.documentExtn != null) {
      if (this.viewableExtensionsList.length > 0) {
        for (let q = 0; q < this.viewableExtensionsList.length; q++) {
          if (this.viewableExtensionsList[q].toUpperCase() == this.documentData.documentExtn.toUpperCase()) {
            this.isViewableFile = false;
            this.appService.getDocumentsToViewForDms(
              this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
                this.loadDataInViewer(data, this.documentData.documentExtn, this.viewer);

              })

            break;
          } else {
            this.isViewableFile = true;
            this.isShowToUploadDiffFile = true;
            this.NotviewableValue.style.display = 'none';
          }

        }
      } else {
        this.isViewableFile = true;
        this.isShowToUploadDiffFile = true;
        this.NotviewableValue.style.display = 'none';
      }

    }
  }

  validateVersion(event: any) {
    if (event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-') {
      event.preventDefault();
    }
  }

  visibleSDownloadPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('downloadPopup', { static: true }) downloadPopup: TemplateRef<any>;
  propertiesdownloadPopupConfig = {
    width: '1200px',
    minHeight: '200px',
    maxHeight: '80vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };



  openDoc(data: any, event: any) {
    event.preventDefault();
    this.isShowAssociatedDocumentField = false;
    this.appService.prevDocumentId = data.documentId;
    this.appService.prevDocVersion = data.version;
    this.isProcessing = true;
    this.appService.getDocumentByDocumentId(
      data.associatedDocumentId, data.associatedDocumentToVersion).subscribe((data: any) => {
        this.documentData = data[0];
        this.appService.setParentFolderId(this.documentData.folderId);
        this.isProcessing = false;
        this.parentFolderId = this.appService.getParentFolderId();
        this.appService.getDmsFolderDataById(this.parentFolderId)
          .subscribe((data: any) => {
            this.folderData = data[0];

            for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
              this.documentTypeDropdown = this.documentTypeDropdown.concat({
                valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
                displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
              });
            }
            if (this.documentData['documentId'] == null || this.documentData['documentId'] == undefined) {
              if (this.folderData.documentTypeCode != null) {
                this.documentTypeDropdown = [];
                let docTypes = this.folderData.documentTypeCode.split(",");
                for (let j = 0; j < docTypes.length; j++) {
                  for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
                    if (docTypes[j] == this.dropDownFordocumentTypeList[i].documentTypeCode) {
                      this.documentTypeDropdown = this.documentTypeDropdown.concat({
                        valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
                        displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
                      });
                    }
                  }
                }

                this.callForFlexifields();

              } else {
                this.isDisableOverridingDocType = false;
              }
            } else {
              this.documentTypeDropdown = [];
              for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
                this.documentTypeDropdown = this.documentTypeDropdown.concat({
                  valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
                  displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
                });

              }
            }
            this.getInitialCall();
          })

        this.viewerValue = document.getElementById('viewerHideShow') as HTMLInputElement
        this.viewerValue.style.display = 'none';
        this.NotviewableValue = document.getElementById('isNotViewableFile') as HTMLInputElement
        if (this.documentData.onlineEditorMode == null) {
          this.NotviewableValue.style.display = 'block';
        } else {
          this.NotviewableValue.style.display = 'none';
        }
      })

  }

  backToMainDoc() {
    this.isShowAssociatedDocumentField = false;
    this.isProcessing = true;
    this.appService.getDocumentByDocumentId(
      this.appService.prevDocumentId, this.appService.prevDocVersion).subscribe((data: any) => {
        this.documentData = data[0];
        this.appService.prevDocumentId = null;
        this.appService.prevDocVersion = null;
        this.appService.setParentFolderId(this.documentData.folderId);
        this.isProcessing = false;
        this.parentFolderId = this.appService.getParentFolderId();
        this.appService.getDmsFolderDataById(this.parentFolderId)
          .subscribe((data: any) => {
            this.folderData = data[0];

            for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
              this.documentTypeDropdown = this.documentTypeDropdown.concat({
                valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
                displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
              });
            }
            if (this.documentData['documentId'] == null || this.documentData['documentId'] == undefined) {
              if (this.folderData.documentTypeCode != null) {
                this.documentTypeDropdown = [];
                let docTypes = this.folderData.documentTypeCode.split(",");
                for (let j = 0; j < docTypes.length; j++) {
                  for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
                    if (docTypes[j] == this.dropDownFordocumentTypeList[i].documentTypeCode) {
                      this.documentTypeDropdown = this.documentTypeDropdown.concat({
                        valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
                        displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
                      });
                    }
                  }
                }
                this.callForFlexifields();
              } else {
                this.isDisableOverridingDocType = false;
              }
            } else {
              this.documentTypeDropdown = [];
              for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
                this.documentTypeDropdown = this.documentTypeDropdown.concat({
                  valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
                  displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
                });
              }
            }
            this.getInitialCall();
          })

        this.viewerValue = document.getElementById('viewerHideShow') as HTMLInputElement
        this.viewerValue.style.display = 'none';
        this.NotviewableValue = document.getElementById('isNotViewableFile') as HTMLInputElement
        if (this.documentData.onlineEditorMode == null) {
          this.NotviewableValue.style.display = 'block';
        } else {
          this.NotviewableValue.style.display = 'none';
        }

      })
  }

  fieldsSearchTxt: string = '';
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }
  onCoverPageCheckboxAutoChanged() {
    this.isCoverpageEnable = true;
    this.isProcessing = true;
    this.appService.getDocumentDetailsFromTable(this.documentData.documentId,
      this.documentData.version).subscribe((data: any) => {
        this.isProcessing = false;
        if (data[0].documentWithCoverPage != null) {
          this.isProcessing = true;
          this.appService.getDocumentsToViewWithCoverPageForDms(
            this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
              this.isProcessing = false;
              if (this.documentData.documentExtn == 'jpg' || this.documentData.documentExtn == 'jpeg' ||
                this.documentData.documentExtn == 'png' || this.documentData.documentExtn == 'JPG' ||
                this.documentData.documentExtn == 'PNG' || this.documentData.documentExtn == 'JPEG') {
                this.showuploaddiv = true;
                this.NotviewableValue.style.display = 'block';
                this.viewerValue.style.display = 'block';
                let blob = new Blob([data.body], { type: "image/*" });
                let url = URL.createObjectURL(blob);
                let image: any = document.getElementById("picture");
                image.src = url;
                this.isShowViewer = false;
              } else {
                this.isShowViewer = true;
                this.loadDataInViewer(data, "pdf", this.viewer);
                //this.document = data;
              }

            })
        } else {
          this.isProcessing = true;
          let obj = {

            documentId: this.documentData.documentId,
            version: this.documentData.version,
            documentNo: this.documentData.documentNo,
            documentName: this.documentData.documentName,
            incudeAmendment: false,
            completeHistory: true,
            incudePageNo: false,
            incudeApproval: true,
            onLastPage: false,
            incudeFooter: false,
            publisherDetails: "Y"
          }
          this.appService.savePublishedDocWithCoverPage(obj).subscribe((response: any) => {
            this.isProcessing = false;
            if (response.resultType == "S") {
              this.isProcessing = true;
              this.appService.getDocumentsToViewWithCoverPageForDms(
                this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
                  this.isProcessing = false;
                  if (this.documentData.documentExtn == 'jpg' || this.documentData.documentExtn == 'jpeg' ||
                    this.documentData.documentExtn == 'png' || this.documentData.documentExtn == 'JPG' ||
                    this.documentData.documentExtn == 'PNG' || this.documentData.documentExtn == 'JPEG') {
                    this.showuploaddiv = true;
                    this.NotviewableValue.style.display = 'block';
                    this.viewerValue.style.display = 'block';
                    let blob = new Blob([data.body], { type: "image/*" });
                    let url = URL.createObjectURL(blob);
                    let image: any = document.getElementById("picture");
                    image.src = url;
                    this.isShowViewer = false;
                  } else {
                    this.isShowViewer = true;
                    this.loadDataInViewer(data, "pdf", this.viewer);
                    //this.document = data;
                  }

                })
            }
          })
        }
      })
  }
  onCoverPageCheckboxChanged(event: any) {
    if (event.checked) {
      this.isCoverpageEnable = true;
      this.isProcessing = true;
      this.appService.getDocumentDetailsFromTable(this.documentData.documentId,
        this.documentData.version).subscribe((data: any) => {
          this.isProcessing = false;
          if (data[0].documentWithCoverPage != null) {
            this.isProcessing = true;
            this.appService.getDocumentsToViewWithCoverPageForDms(
              this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
                this.isProcessing = false;
                if (this.documentData.documentExtn == 'jpg' || this.documentData.documentExtn == 'jpeg' ||
                  this.documentData.documentExtn == 'png' || this.documentData.documentExtn == 'JPG' ||
                  this.documentData.documentExtn == 'PNG' || this.documentData.documentExtn == 'JPEG') {
                  this.showuploaddiv = true;
                  this.NotviewableValue.style.display = 'block';
                  this.viewerValue.style.display = 'block';
                  let blob = new Blob([data.body], { type: "image/*" });
                  let url = URL.createObjectURL(blob);
                  let image: any = document.getElementById("picture");
                  image.src = url;
                  this.isShowViewer = false;
                } else {
                  this.isShowViewer = true;
                  this.loadDataInViewer(data, "pdf", this.viewer);
                  //this.document = data;
                }

              })
          } else {
            this.isProcessing = true;
            let obj = {

              documentId: this.documentData.documentId,
              version: this.documentData.version,
              documentNo: this.documentData.documentNo,
              documentName: this.documentData.documentName,
              incudeAmendment: false,
              completeHistory: true,
              incudePageNo: false,
              incudeApproval: true,
              onLastPage: false,
              incudeFooter: false,
              publisherDetails: "Y"
            }
            this.appService.savePublishedDocWithCoverPage(obj).subscribe((response: any) => {
              this.isProcessing = false;
              if (response.resultType == "S") {
                this.isProcessing = true;
                this.appService.getDocumentsToViewWithCoverPageForDms(
                  this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
                    this.isProcessing = false;
                    if (this.documentData.documentExtn == 'jpg' || this.documentData.documentExtn == 'jpeg' ||
                      this.documentData.documentExtn == 'png' || this.documentData.documentExtn == 'JPG' ||
                      this.documentData.documentExtn == 'PNG' || this.documentData.documentExtn == 'JPEG') {
                      this.showuploaddiv = true;
                      this.NotviewableValue.style.display = 'block';
                      this.viewerValue.style.display = 'block';
                      let blob = new Blob([data.body], { type: "image/*" });
                      let url = URL.createObjectURL(blob);
                      let image: any = document.getElementById("picture");
                      image.src = url;
                      this.isShowViewer = false;
                    } else {
                      this.isShowViewer = true;
                      this.loadDataInViewer(data, "pdf", this.viewer);
                      //this.document = data;
                    }

                  })
              }
            })
          }
        })
    } else {
      this.isCoverpageEnable = false;
      this.isViewableFile = false;
      this.appService.getDocumentsToViewForDms(
        this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
          if (this.documentData.documentExtn == 'jpg' || this.documentData.documentExtn == 'jpeg' ||
            this.documentData.documentExtn == 'png' || this.documentData.documentExtn == 'JPG' ||
            this.documentData.documentExtn == 'PNG' || this.documentData.documentExtn == 'JPEG') {
            if (this.documentData.onlineEditorMode == null) {
              this.showuploaddiv = true;
              this.NotviewableValue.style.display = 'block';
              this.viewerValue.style.display = 'block';
              let blob = new Blob([data.body], { type: "image/*" });
              let url = URL.createObjectURL(blob);
              let image: any = document.getElementById("picture");
              image.src = url;
              this.isShowViewer = false;
            }
          } else {
            if (this.documentData.onlineEditorMode == null) {
              this.isShowViewer = true;
              this.loadDataInViewer(data, this.documentData.documentExtn, this.viewer);

            }
            this.document = data;
          }

        })
    }
  }

  @ViewChild('angularEditorTextarea', { static: true }) angularEditorTextarea: TemplateRef<any>;
  visibleAngularEditor: MatDialogRef<TemplateRef<any>>;

  angularEditorTextareaConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  editorValue: any;
  openEditor(value: string) {
    this.editorValue = value;
    this.visibleAngularEditor = this.dialog.open(this.angularEditorTextarea, this.angularEditorTextareaConfig);
  }

  cancelAngularEditorData() {
    this.visibleAngularEditor.close();
  }

}
